import React, { useState, useEffect, useRef, useMemo, useContext, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTransactionDocumentPageData, resetTransactionDocumentPage, setTransactionDocuments, setTransactionMonthClosed } from '../../store/reducers/transactionDocumentPageSlice';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu.jsx';
import Select from 'react-select';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import DocumentService from '../../Services/documents.service.js';
import UserService from '../../Services/user.service.js';
import './TransactionDocuments.css';
import backIcon from '../../assests/images/left-arrow.png';
import calendarIcon from '../../assests/images/calendar.png';
import EnumsService from '../../Services/enums.service.js';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js'
import { ToastContainer, toast } from "react-toastify";
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import { useSignalR } from '../../Contexts/signalR.js';
import SignaturePad from 'react-signature-canvas';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service.js';
import PuffLoader from "react-spinners/PuffLoader";
import JSZip from "jszip";
import cancelIcon from "../../assests/images/cancel.png";
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Iframe from 'react-iframe';
import ClientService from '../../Services/client.service.js';
import addIcon from "../../assests/images/plusO.png";
import loadingAnimation from "../../assests/images/Animation.gif";
import Constants from '../../assests/Constants/constants.js';
import Modal from '@mui/material/Modal';
import ReferencesTreeModal from '../../Components/TransactionDocuments/SubComponents/ReferencesTreeModal.jsx';
import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DraggableModal from '../../Components/DraggableModal/DraggableModal.js';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, TextField, Chip, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import dayjs, { Dayjs } from 'dayjs';
import DownloadIconMui from '@mui/icons-material/Download';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import DateInput from '../../Components/DateInput/DateInput.js';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import TransactionDocumentDataGridComponent from '../../Components/TransactionDocuments/SubComponents/TransactionDocumentDataGridComponent.jsx';
import {
    getConversionDescendants,
    getGroupedOpenInvoices,
    isConversionCancelBlocked,
    LIFECYCLE_STATUS,
    getProcessingStatus,
    getStatusKey,
    parseOverAllocationError,
    formatOverAllocationMessage,
    pickLinkPrimary,
} from '../../Components/TransactionDocuments/documentLifecycle.js';
import { calculateVatAmount, getVatValue } from '../../Utils/GetVatValue.js';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';
import AutocompleteSelectFilter from '../../Components/Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import '../Document/Document.scss';
import AddItemsModal from '../../Components/TransactionDocuments/SubComponents/AddItemsModal.jsx';
import ClientItemsService from '../../Services/clientItems.service';
import GenerateDocumentModal from '../../Components/TransactionDocuments/SubComponents/GenerateDocumentModal';
import TaxAuthorityService from '../../Services/taxAuthority.service';
import ReceiptItemsModal from '../../Components/TransactionDocuments/SubComponents/ReceiptItemsModal';
import { getIsraelInvoiceAmountLimit } from '../../Utils/GetIsraelInvoiceAmountLimit.js';
import { PDFDocument } from 'pdf-lib';
import { mergeAndPrint, mergeIntoViewer } from '../../Utils/mergeAndPrint.js';
import MergedPdfPrint from '../../Components/TransactionDocuments/SubComponents/MergedPdfPrint.js';
import { useReactToPrint } from 'react-to-print';
import EmailModal from '../../Components/TransactionDocuments/SubComponents/EmailModal.js';
import WhatsAppModal from '../../Components/TransactionDocuments/SubComponents/WhatsAppModal.js';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs/CustomBreadcrumbs.jsx'
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import SubAccountantService from '../../Services/subAccountant.service.js';
import DocumentSettingsDialog from '../../Components/Widgets/DocumentSettingsDialog/DocumentSettingsDialog';
import DocumentChoiceModal from '../../Components/TransactionDocuments/SubComponents/DocumentChoiceModal.jsx';
import CancelDocumentsModal from '../../Components/TransactionDocuments/SubComponents/CancelDocumentsModal.jsx';
import LinkDocumentsModal from '../../Components/TransactionDocuments/SubComponents/LinkDocumentsModal.jsx';
import TaxAuthorityErrorModal from '../../Components/TaxAuthorityErrorModal/TaxAuthorityErrorModal.jsx';
import TaxAuthorityProblemInvoicesModal from '../../Components/TaxAuthorityErrorModal/TaxAuthorityProblemInvoicesModal.jsx';
import SelfInvoicesTab from '../../Components/TransactionDocuments/SubComponents/SelfInvoicesTab.jsx';
import TransactionSummariesTab from '../../Components/TransactionDocuments/SubComponents/TransactionSummariesTab.jsx';
import SelfIncomesService from '../../Services/selfIncomes.service.js';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import * as XLSX from 'xlsx';

import { useClientNavigation } from '../../hooks/useClientNavigation.js';
registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it

const INVOICE_RECEIPT_TYPE = 6;
const INCOME_SUMMARY_TYPES = [4, 5, 6];

const toUtcDayStart = (date) => {
    const value = date instanceof Date ? date : new Date(date);
    return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0, 0));
};

const toUtcDayEnd = (date) => {
    const value = date instanceof Date ? date : new Date(date);
    return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), 23, 59, 59, 999));
};

const parseStoredDay = (stored, fallback) => {
    if (!stored) return fallback;
    const value = new Date(stored);
    if (Number.isNaN(value.getTime())) return fallback;
    return new Date(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate());
};

const IssuedDocumentDateInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
    <button type="button" className="issued-doc-date-input" onClick={onClick} ref={ref}>
        {value || placeholder}
    </button>
));

const InvoiceModalTypes = [
    // 0 -> Incomes
    {
        controller: 'Incomes',
        endPoint: 'GenerateIncomePdf',
        draftEndPoint: 'GenerateIncomeDraftPdf',
        type: '',
        TransactionDocumentType: '',
        TransactionDocumentTitle: '',
        title: 'generateInvoice',
        screen: '/Document',
        typeName: 'Incomes',
    },
    // 1 -> Refunds
    {
        controller: 'Incomes',
        endPoint: 'GenerateRefundIncomePdf',
        draftEndPoint: 'GenerateRefundIncomeDraftPdf',
        type: '',
        TransactionDocumentType: '',
        TransactionDocumentTitle: '',
        title: 'generateCreditNote',
        screen: '/Document',
        typeName: 'Incomes',
    },
    // 2 -> Quotations
    {
        controller: "TransactionDocuments",
        endPoint: "GenerateTransactionDocumentPdf",
        draftEndPoint: "GenerateTransactionDocumentDraftPdf",
        type: "quotation",
        TransactionDocumentType: "Quotation",
        TransactionDocumentTitle: "הצעת מחיר",
        title: "generateQuotation",
        screen: '/TransactionDocuments',
        typeName: 'TransactionDocuments',
    },
    // 3 -> Orders
    {
        controller: "TransactionDocuments",
        endPoint: "GenerateTransactionDocumentPdf",
        draftEndPoint: "GenerateTransactionDocumentDraftPdf",
        type: "order",
        TransactionDocumentType: "Order",
        TransactionDocumentTitle: "הזמנה",
        title: "generateOrder",
        screen: '/TransactionDocuments',
        typeName: 'TransactionDocuments',
    },
    // 4 -> Transactions
    {
        controller: "TransactionDocuments",
        endPoint: "GenerateTransactionDocumentPdf",
        draftEndPoint: "GenerateTransactionDocumentDraftPdf",
        type: "transaction",
        TransactionDocumentType: "Transaction",
        TransactionDocumentTitle: "חשבון עסקה",
        title: "generateTransactionInvoice",
        screen: '/TransactionDocuments',
        typeName: 'TransactionDocuments',
    },
    // 5 -> InvoiceReceipts
    {
        controller: 'PaymentAcceptances',
        endPoint: 'GeneratePaymentAcceptanceDocumentPdf',
        draftEndPoint: 'GeneratePaymentAcceptanceDocumentDraftPdf',
        TransactionDocumentType: '',
        TransactionDocumentTitle: 'חשבונית מס קבלה',
        title: 'invoiceReceipt',
        screen: '/PaymentAcceptance',
        typeName: 'PaymentAcceptances',
    },
    // 6 -> Receipts
    {
        controller: 'PaymentAcceptances',
        endPoint: 'GeneratePaymentAcceptanceDocumentPdf',
        draftEndPoint: 'GeneratePaymentAcceptanceDocumentDraftPdf',
        TransactionDocumentType: '',
        TransactionDocumentTitle: 'קבלה',
        title: 'receipt',
        screen: '/PaymentAcceptance',
        typeName: 'PaymentAcceptances',
    },
    // 7 -> Cancel InvoiceReceipts
    {
        controller: 'PaymentAcceptances',
        endPoint: 'CancelPaymentAcceptanceDocumentPdf',
        draftEndPoint: 'CancelPaymentAcceptanceDocumentDraftPdf',
        TransactionDocumentType: '',
        TransactionDocumentTitle: "חשבונית מס קבלה - ביטול",
        title: "חשבונית מס קבלה - ביטול",
        screen: '/PaymentAcceptance',
        typeName: 'PaymentAcceptances',
    },
    // 8 -> Cancel Receipts
    {
        controller: 'PaymentAcceptances',
        endPoint: 'CancelPaymentAcceptanceDocumentPdf',
        draftEndPoint: 'CancelPaymentAcceptanceDocumentDraftPdf',
        TransactionDocumentType: '',
        TransactionDocumentTitle: "קבלה - ביטול",
        title: "קבלה - ביטול",
        screen: '/PaymentAcceptance',
        typeName: 'PaymentAcceptances',
    },
    // 9 -> Delivery Note
    {
        controller: 'Inventory',
        endPoint: 'GenerateInventoryDocumentPdf',
        draftEndPoint: 'GenerateInventoryDocumentDraftPdf',
        TransactionDocumentType: 'DeliveryNote',
        TransactionDocumentTitle: "תעודת משלוח",
        title: "generateDeliveryNote",
        screen: '/Inventory',
        typeName: 'Inventory',
    },
    // 10 -> Return Note
    {
        controller: 'Inventory',
        endPoint: 'GenerateInventoryDocumentPdf',
        draftEndPoint: 'GenerateInventoryDocumentDraftPdf',
        TransactionDocumentType: 'ReturnNote',
        TransactionDocumentTitle: "תעודת החזרה",
        title: "generateReturnNote",
        screen: '/Inventory',
        typeName: 'Inventory',
    },
    // 11 -> Stock Release
    {
        controller: 'Inventory',
        endPoint: 'GenerateInventoryDocumentPdf',
        draftEndPoint: 'GenerateInventoryDocumentDraftPdf',
        TransactionDocumentType: 'StockRelease',
        TransactionDocumentTitle: "יציאת מלאי",
        title: "generateStockRelease",
        screen: '/Inventory',
        typeName: 'Inventory',
    },
    // 12 -> Stock Intake
    {
        controller: 'Inventory',
        endPoint: 'GenerateInventoryDocumentPdf',
        draftEndPoint: 'GenerateInventoryDocumentDraftPdf',
        TransactionDocumentType: 'StockIntake',
        TransactionDocumentTitle: "כניסת מלאי",
        title: "generateStockIntake",
        screen: '/Inventory',
        typeName: 'Inventory',
    },
];

/** Indices for tax-authority OAuth / confirmation rules, and month-closure checks. Includes invoice-receipt & receipt cancels (7–8); those use index 7/8, not 5. */
// Modal indices whose documents reach the Tax Authority: 0 tax invoice, 1 credit note,
// 4 transaction account, 5 invoice-receipt, 7 invoice-receipt cancel. A plain receipt
// (6 generate, 8 cancel) is never reported, so it must never enter the decision flow — its
// reference series is its own and may reuse a held invoice's number.
const MODAL_INDICES_TAX_AUTHORITY = [0, 1, 4, 5, 7];

// Sentinel makat used to mark the auto-generated "Rounding Difference" item
// when the user applies the Round button in ReceiptItemsModal. Mirrors the
// value used in CreateReceipt.jsx so both flows produce identical line items.
const ROUNDING_MAKAT = '-100';

const ACTION_TO_TYPE_INDEX = {
    cancel_quotation: { index: 2, negative: true },
    cancel_order: { index: 3, negative: true },
    cancel_transaction: { index: 4, negative: true },
    cancel_creditTaxInvoice: { index: 0, negative: false },
    generate_quotation: { index: 2, negative: false },
    generate_order: { index: 3, negative: false },
    generate_transaction: { index: 4, negative: false },
    generate_invoice: { index: 0, negative: false },
    generate_credit_invoice: { index: 1, negative: false },
    generate_invoice_receipt: { index: 5, negative: false },
    generate_receipt: { index: 6, negative: false },
    cancel_receipt_invoice: { index: 7, negative: false },
    cancel_receipt: { index: 8, negative: false },
    generate_receipt_deferred: { index: 6, negative: false },
    // NOTE: Inventory documents (11-14) have NO cancel actions - excluded intentionally
};

const ALLOWED_TAX_EXEMPT_GEN = [
    'generate_quotation',
    'generate_order',
    'generate_transaction',
    'generate_receipt',
    'generate_receipt_deferred',
];

const QUOTATION_TYPE = 1; // הצעת מחיר
const ORDER_TYPE = 2; // הזמנה
const DELIVERY_NOTE_TYPE = 11;
const TRANSACTION_ACCOUNT_TYPE = 3; // חשבון עסקה
const TAX_INVOICE_TYPE = 4; // חשבונית מס
const STATUS_HIDDEN_ROW_TYPES = [5, 8, 9, 10, 12, 13, 14]; // CreditTaxInvoice, Deposit, DeferredReceipt, PrintedCheck, ReturnNote, StockRelease, StockIntake

/** Ids of the source row(s) this document is generated from (any TransactionDocumentType). */
const collectSourceDocumentIds = (documentInfo) => {
    const docs = documentInfo?.sourceDocuments?.length
        ? documentInfo.sourceDocuments
        : (documentInfo ? [documentInfo] : []);
    return docs.map((d) => d.id).filter(Boolean);
};

const haveSameCustomerAccount = (rows) =>
    new Set(rows.map((r) => String(r?.accountCodeId ?? ''))).size === 1;

const haveSameDocumentType = (rows) =>
    rows.length >= 2 &&
    new Set(rows.map((r) => Number(r?.transactionDocumentType))).size === 1;

const sumDocumentItemLines = (items = []) =>
    items.reduce((sum, item) => {
        const price = Number(item?.price) || 0;
        const quantity = Number(item?.quantity) || 0;
        const discount = Number(item?.discount) || 0;
        const baseAmount = price * quantity;
        return sum + (baseAmount - (baseAmount * discount) / 100);
    }, 0);

/** VAT rate (e.g. 0.18) for a source document; 0 when document has no VAT. */
const getDocumentVatRate = (doc) => {
    if (doc?.vat === 0 || doc?.vat === '0') return 0;

    const vatMarker = Number(doc?.vat);
    const isPal = vatMarker === 16 || vatMarker === 17;
    return getVatValue(doc?.documentDate || new Date(), false, isPal);
};

const itemIncludesVat = (item) => {
    if (item?.includeVat !== undefined && item?.includeVat !== null) return item.includeVat !== false;
    if (item?.IncludeVat !== undefined && item?.IncludeVat !== null) return item.IncludeVat !== false;
    return true;
};

/**
 * Same rule as CreateInvoice/CreateReceipt computeTotalInvoiceAmount:
 * - priceIncludingVAT=true  → line amount is already final (do not add VAT)
 * - priceIncludingVAT=false → add VAT only when the item itself has includeVat=true
 */
const computeDocumentPayableAmount = (items, priceIncludingVAT, vatRate) =>
    (items || []).reduce((sum, item) => {
        const lineAmount = sumDocumentItemLines([item]);
        if (priceIncludingVAT) return sum + lineAmount;
        if (itemIncludesVat(item) && vatRate > 0) {
            return sum + lineAmount * (1 + vatRate);
        }
        return sum + lineAmount;
    }, 0);

/**
 * Detect document-level PriceIncludingVAT the same way duplicate_document does:
 * if raw item sum equals document amount → prices already include VAT.
 */
const detectDocumentPriceIncludingVat = (items, docAmount, vatRate) => {
    if (!items?.length) return true;

    const amount = Math.round((Number(docAmount) || 0) * 100) / 100;
    if (!amount) return true;

    const asInclusive = Math.round(computeDocumentPayableAmount(items, true, vatRate) * 100) / 100;
    const asExclusive = Math.round(computeDocumentPayableAmount(items, false, vatRate) * 100) / 100;
    const eps = Math.max(0.05, Math.abs(amount) * 0.001);

    // Credit documents keep a negative amount with positive line prices → compare magnitudes.
    const diffIncl = Math.abs(Math.abs(asInclusive) - Math.abs(amount));
    const diffExcl = Math.abs(Math.abs(asExclusive) - Math.abs(amount));

    // Prefer exact / near matches first (CreateInvoice duplicate logic).
    if (diffIncl <= eps) return true;
    if (diffExcl <= eps) return false;
    return diffIncl <= diffExcl;
};

/**
 * Normalize one source document's items to VAT-inclusive unit prices so the merged
 * document can be generated with PriceIncludingVAT=true (CreateInvoice convention).
 *
 * Per document:
 *  1) Detect whether THAT document's prices already include VAT (items sum vs amount)
 *  2) For each item, apply CreateInvoice rules using item.includeVat
 *  3) Store the payable (gross) amount as the new unit price
 */
const normalizeSourceDocItemsToIncludeVat = (items, sourceDoc) => {
    const list = (items || []).filter(Boolean);
    const docAmount = Math.round((Number(sourceDoc?.amount) || 0) * 100) / 100;
    const vatRate = getDocumentVatRate(sourceDoc);

    // No catalogue items — keep the document amount as a single line.
    if (!list.length) {
        if (!docAmount) return [];
        return [{
            makat: sourceDoc?.reference ? String(sourceDoc.reference) : '',
            name: sourceDoc?.reference ? String(sourceDoc.reference) : 'Document',
            quantity: 1,
            price: docAmount,
            discount: 0,
            includeVat: true,
            itemId: null,
            sourceDocumentId: sourceDoc?.id,
            sourceDocumentReference: sourceDoc?.reference,
        }];
    }

    const priceIncludingVAT = detectDocumentPriceIncludingVat(list, docAmount, vatRate);

    return list.map((item) => {
        const includeVat = itemIncludesVat(item);
        const quantity = Number(item.quantity) || 0;
        const discount = Number(item.discount) || 0;
        const lineAmount = sumDocumentItemLines([item]);

        // CreateInvoice payable contribution for this line on the SOURCE document.
        let payableLine = lineAmount;
        if (!priceIncludingVAT && includeVat && vatRate > 0) {
            payableLine = lineAmount * (1 + vatRate);
        }
        payableLine = Math.round(payableLine * 100) / 100;

        // Convert to a VAT-inclusive unit price for the merged document.
        let price = Number(item.price) || 0;
        if (quantity > 0) {
            const discountFactor = 1 - discount / 100;
            price = discountFactor !== 0
                ? payableLine / (quantity * discountFactor)
                : payableLine / quantity;
            price = Math.round(price * 100) / 100;
        } else {
            price = payableLine;
        }

        return {
            ...item,
            price,
            // Merged doc uses PriceIncludingVAT=true; keep whether the line is taxable.
            includeVat,
            sourceDocumentId: sourceDoc?.id,
            sourceDocumentReference: sourceDoc?.reference,
            sourcePriceIncludingVAT: priceIncludingVAT,
        };
    });
};

/**
 * Merge items from many source docs, normalizing each document independently
 * (same VAT rules as CreateInvoice / CreateReceipt).
 */
const mergeMultiSourceDocumentItems = (rows, itemsArrays) => {
    const mergedItems = rows.flatMap((row, index) =>
        normalizeSourceDocItemsToIncludeVat(itemsArrays[index], row)
    );
    // Authoritative total = sum of each source document's amount to pay.
    const totalFromDocs = Math.round(
        rows.reduce((sum, d) => sum + (Number(d?.amount) || 0), 0) * 100
    ) / 100;
    const totalFromItems = Math.round(sumDocumentItemLines(mergedItems) * 100) / 100;

    return {
        mergedItems,
        // Prefer document amounts (matches PDF "סה״כ לתשלום"); items should match after normalization.
        totalAmount: totalFromDocs || totalFromItems,
        priceIncludingVat: true,
    };
};

/**
 * Returns the bulk generate action when all selected rows are the same eligible source type.
 * - Quotations (1), Orders (2), Delivery notes (11) or Transaction accounts (3) → generate invoice
 * - Tax invoices (4) → generate receipt
 */
const getMultiDocumentGenerateConfig = (rows) => {
    if (!haveSameDocumentType(rows)) return null;
    if (!rows.every((r) => !r?.isCanceled)) return null;

    const type = Number(rows[0]?.transactionDocumentType);

    const invoiceSourceConfigs = {
        [QUOTATION_TYPE]: {
            sourceLabelKey: 'SourceQuotations',
            selectErrorKey: 'SelectMultipleQuotations',
            missingItemsKey: 'QuotationsMissingItems',
            differentCustomersKey: 'QuotationsDifferentCustomers',
        },
        [ORDER_TYPE]: {
            sourceLabelKey: 'SourceOrders',
            selectErrorKey: 'SelectMultipleOrders',
            missingItemsKey: 'OrdersMissingItems',
            differentCustomersKey: 'OrdersDifferentCustomers',
        },
        [DELIVERY_NOTE_TYPE]: {
            sourceLabelKey: 'SourceDeliveryNotes',
            selectErrorKey: 'SelectMultipleDeliveryNotes',
            missingItemsKey: 'DeliveryNotesMissingItems',
            differentCustomersKey: 'DeliveryNotesDifferentCustomers',
        },
        [TRANSACTION_ACCOUNT_TYPE]: {
            sourceLabelKey: 'SourceTransactionAccounts',
            selectErrorKey: 'SelectMultipleTransactionAccounts',
            missingItemsKey: 'TransactionAccountsMissingItems',
            differentCustomersKey: 'TransactionAccountsDifferentCustomers',
        },
    };

    if (invoiceSourceConfigs[type]) {
        return {
            actionValue: 'generate_invoice',
            actionLabel: 'menu.generateInvoice',
            menuValue: 'generate_invoice_multi',
            sourceType: type,
            requiresTaxableClient: true,
            ...invoiceSourceConfigs[type],
        };
    }

    if (type === TAX_INVOICE_TYPE) {
        return {
            actionValue: 'generate_receipt',
            actionLabel: 'menu.generateReceipt',
            menuValue: 'generate_receipt_multi',
            sourceType: type,
            sourceLabelKey: 'SourceInvoices',
            selectErrorKey: 'SelectMultipleInvoices',
            missingItemsKey: 'InvoicesMissingItems',
            differentCustomersKey: 'InvoicesDifferentCustomers',
            requiresTaxableClient: false,
        };
    }

    return null;
};

/** Row action on a TaxInvoice grouped with other open invoices of the same source. */
const GROUP_RECEIPT_GENERATE = 'generate_receipt_group';

const canShowMultiDocumentGenerate = (rows, isTaxExempt) => {
    const config = getMultiDocumentGenerateConfig(rows);
    if (!config) return false;
    if (config.requiresTaxableClient && isTaxExempt) return false;
    return true;
};

function TransactionDocuments() {
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const dispatch = useDispatch();

    const transactionPage = useSelector((state) => state.transactionDocumentPageSlice || {});
    const rawDocumentsFromRedux = transactionPage.documents || [];
    const pageLoading = transactionPage.loading || false;
    const isClosedReportingMonthFromRedux = transactionPage.isClosedReportingMonth ?? false;

    const data = useMemo(() => rawDocumentsFromRedux.map((d) => {
        const vatAmount = calculateVatAmount(d.amount, d.vat, d.documentDate);
        return { ...d, vatAmount, netAmount: (d.amount || 0) - vatAmount };
    }), [rawDocumentsFromRedux]);

    const [localLoading, setLocalLoading] = useState(false);
    const loading = pageLoading || localLoading;
    const isClosedReportingMonth = isClosedReportingMonthFromRedux;
    const docFetchInFlightRef = useRef(false);
    const initialFetchDoneRef = useRef(false);

    const [modalVisible, setModalVisible] = useState(false);
    const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const GENERIC_MENU = [
        { label: 'Print', value: 'bulk_print' },
        { label: 'SendByEmail', value: 'bulk_email' },
        { label: 'SendByWhatsApp', value: 'bulk_whatsapp' },
        { label: 'Download', value: 'bulk_download' },
    ];

    const [invoiceModalChoiceVisible, setInvoiceModalChoiceVisible] = useState(false);
    const [invoiceModalChoiceSpecificVisible, setInvoiceModalChoiceSpecificVisible] = useState(false);
    const [invoiceCreatorType, setInvoiceCreatorType] = useState('');
    const { goBack } = useContext(NavHistoryContext);
    const [refsOpen, setRefsOpen] = useState(false);
    const [signatureReferenceInvoiceModalVisible, setSignatureReferenceInvoiceModalVisible] = useState(false);
    const [documentDate, setDocumentDate] = useState(new Date());
    const [documentCost, setDocumentCost] = useState('');
    const [documentVat, setDocumentVat] = useState(100);
    const [documentReference, setDocumentReference] = useState('');
    const [sortCodeId, setCodeId] = useState('');
    const [accountCodeName, setAccountCodeName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [accountCodeId, setAccountCodeId] = useState('');
    const [description, setDescription] = useState('');
    const [documents, setDocuments] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [okMessage, setOkMessage] = useState('');
    const [user, setUser] = useState(null);
    const [isTaxExempt, setIsTaxExempt] = useState(false);

    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const [sortByTitleAsc, setSortByTitleAsc] = useState(true); // Sort by title ascending by default
    const [sortByDateAsc, setSortByDateAsc] = useState(false); // Sort by title ascending by default
    const [searchQuery, setSearchQuery] = useState('');
    const [currentSort, setCurrentSort] = useState("date");
    const [sortByAmountAsc, setSortByAmountAsc] = useState(true); // Sort by amount ascending by default
    const [sortByNewest, setSortByNewest] = useState(true);
    const modalCreateDocumentRef = useRef(); // Reference to the modal content

    const signatureReferenceInvoiceModalVisibleRef = useRef();
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [creditAccountOption, setCreditAccountOption] = useState('');
    const [debitAccountOption, setDebitAccountOption] = useState('');
    const location = useLocation();
    const [editingRow, setEditingRow] = useState(null);
    const [editedItem, setEditedItem] = useState({});
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [originalAccountCardId, setOriginalAccountCardId] = useState('');
    const [sortDate, setSortDate] = useState(() => {
        const storedDateString = localStorage.getItem('Date');
        return storedDateString ? new Date(storedDateString) : new Date();
    });
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'he');
    const direction = i18n.dir();
    const [showRefsModal, setShowRefsModal] = useState(false);
    const [documentSettingsModalOpen, setDocumentSettingsModalOpen] = useState(false);
    const handleOpenReferences = () => setShowRefsModal(true);
    const handleCloseReferences = () => setShowRefsModal(false);

    const { viewDocumentCreate } = useClientNavigation(client);

    const [startDate, setStartDate] = useState(() => {
        const storedDateString = localStorage.getItem('StartDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });; // Start date for range
    const [endDate, setEndDate] = useState(() => {
        const storedDateString = localStorage.getItem('EndDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });; // End date for range


    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });;
    const [filterByDocumentDate, setFilterByDocumentDate] = useState(() =>
        localStorage.getItem('transactionDocsFilterByDocumentDate') === 'true'
    );
    const [documentDay, setDocumentDay] = useState(() =>
        parseStoredDay(localStorage.getItem('TransactionDocumentDay'), new Date(localStorage.getItem('Date') || Date.now()))
    );
    const [documentDayStart, setDocumentDayStart] = useState(() =>
        parseStoredDay(localStorage.getItem('TransactionDocumentDayStart'), new Date(localStorage.getItem('StartDate') || Date.now()))
    );
    const [documentDayEnd, setDocumentDayEnd] = useState(() =>
        parseStoredDay(localStorage.getItem('TransactionDocumentDayEnd'), new Date(localStorage.getItem('EndDate') || Date.now()))
    );
    const [paymentMethods, setPaymentMethods] = useState([]);
    const filterByDocumentDateRef = useRef(filterByDocumentDate);
    filterByDocumentDateRef.current = filterByDocumentDate;
    const documentDayRef = useRef(documentDay);
    documentDayRef.current = documentDay;
    const documentDayStartRef = useRef(documentDayStart);
    documentDayStartRef.current = documentDayStart;
    const documentDayEndRef = useRef(documentDayEnd);
    documentDayEndRef.current = documentDayEnd;
    const isRangeRef = useRef(isRange);
    isRangeRef.current = isRange;
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [downloadStartDate, setDownloadStartDate] = useState(null); // Start date for range
    const [downloadEndDate, setDownloadEndDate] = useState(null);
    const [downloadAmount, setDownloadAmount] = useState();
    const [downloadAccountCodeId, setDownloadAccountCodeId] = useState([]);
    const [isDateEnabled, setIsDateEnabled] = useState(false);
    const { documentUpdate } = useSignalR();
    const [stautsCheck, setStautsCheck] = useState(false);
    const [isFirstUserFetched, setIsFirstUserFetched] = useState(false);
    const [actionType, setActionType] = useState('delete');

    // invoice Details // 
    const sigPad = useRef({});
    const [invoiceDescription, setInvoiceDescription] = useState('');
    const [invoiceReference, setInvoiceReference] = useState('');
    const [invoiceClientName, setInvoiceClientName] = useState('');
    const [invoiceClientCaseId, setInvoiceClientCaseId] = useState('');
    const [invoiceClientLocation, setInvoiceClientLocation] = useState('');
    const [invoiceClientEmail, setInvoiceClientEmail] = useState('');
    const [invoiceClientPhoneNumber, setInvoiceClientPhoneNumber] = useState('');
    const [invoiceSignature, setInvoiceSignature] = useState('');
    const [invoiceAccountCodeId, setInvoiceAccountCodeId] = useState('');
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [addNewItem, setAddNewItem] = useState(false);
    const [addNewAccountCard, setAddNewAccountCard] = useState(false);
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [addNewSignatureReference, setAddNewSignatureReference] = useState(false);
    const [newItems, setNewItems] = useState([]); // To store new items
    const [addItemFlags, setAddItemFlags] = useState([]); // Array of booleans to track add new item mode per index
    const [priceIncludingVAT, setPriceIncludingVAT] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const [documentTypes, setDocumentTypes] = useState([]);
    const [selectedMakats, setSelectedMakats] = useState([]);
    const [selectedClientId, setSelectedClientId] = useState(null);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [makatMatchingDocIds, setMakatMatchingDocIds] = useState(null);
    const [hasSelfInvoices, setHasSelfInvoices] = useState(false);
    const [documentsTab, setDocumentsTab] = useState(0); // 0 = transaction docs, 1 = self invoices, 2 = summaries

    const summaryPeriodLabel = useMemo(() => {
        const day = (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '');
        const month = (value) => (value ? dayjs(value).format('MM/YYYY') : '');
        if (filterByDocumentDate) {
            return isRange ? `${day(documentDayStart)} - ${day(documentDayEnd)}` : day(documentDay);
        }
        return isRange ? `${month(startDate)} - ${month(endDate)}` : month(sortDate);
    }, [filterByDocumentDate, isRange, documentDay, documentDayStart, documentDayEnd, startDate, endDate, sortDate]);

    const [autoFilling, setAutoFilling] = useState(true);
    const tableContainerRef = useRef();
    const customScrollbarRef = useRef();
    const [focused, setFocused] = useState(false);
    const { setMenuProps } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    useEffect(() => {
        return () => { dispatch(resetTransactionDocumentPage()); };
    }, [dispatch]);

    // Show CancelDocuments modal after data fetching is complete
    useEffect(() => {
        console.log('CancelModal Check:', {
            showCancelModal: location.state?.showCancelModal,
            isFirstUserFetched: isFirstUserFetched,
            locationState: location.state
        });
        
        if (location.state?.showCancelModal && isFirstUserFetched) {
            
            // Small delay to ensure the page is fully rendered
            const timer = setTimeout(() => {
                setShowCancelDocumentsModal(true);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [location.state?.showCancelModal, isFirstUserFetched]);
    // genereate docuemnts
    const [showAddItemsModal, setShowAddItemsModal] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);
    const [currentDoc, setCurrentDoc] = useState(null);
    const [sourceDocs, setSourceDocs] = useState([]);
    const [conversionChildren, setConversionChildren] = useState([]);
    const [docItems, setDocItems] = useState([]);
    const [clientItems, setClientItems] = useState([]);
    const [showGenerateModal, setShowGenerateModal] = useState(false);
    // "Receipt Items" scenario
    const [showReceiptItemsModal, setShowReceiptItemsModal] = useState(false);
    const [resumeInvoiceCreation, setResumeInvoiceCreation] = useState(false);
    /* modal with the e‑mail input */
    const [showEmailModal, setShowEmailModal] = useState(false);
    /* list of e-mail addresses entered by the user */
    const [targetEmails, setTargetEmails] = useState([]);
    /* modal with the WhatsApp number input */
    const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
    /* list of phone numbers entered by the user */
    const [targetPhones, setTargetPhones] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [showCancelDocumentsModal, setShowCancelDocumentsModal] = useState(false);
    /** "שיוך מסמכים": { documentId, pairDocumentIds } of the selected rows, null when closed. */
    const [linkDocumentsTarget, setLinkDocumentsTarget] = useState(null);
    const [isTaxAuthorityErrorModalVisible, setIsTaxAuthorityErrorModalVisible] = useState(false);
    const [pendingMergedDataForTaxError, setPendingMergedDataForTaxError] = useState(null);
    const [pendingDecisionStatus, setPendingDecisionStatus] = useState(null);
    const [resolvePendingMode, setResolvePendingMode] = useState(false);
    const [pendingResumeKind, setPendingResumeKind] = useState(null); // 'draft' | 'create'
    const [showProblemInvoicesModal, setShowProblemInvoicesModal] = useState(false);
    
    // Reset modal state when location changes
    useEffect(() => {
        setShowCancelDocumentsModal(false);
    }, [location.pathname]);

    // Load Tax Authority pending decision status for this case (next tax-invoice reference)
    const refreshPendingDecisionStatus = async (documentType = 'TaxInvoice') => {
        if (!client?.caseId || !token) return null;
        try {
            const status = await TaxAuthorityService.getPendingInvoiceDecisionStatus(
                client.caseId,
                token,
                documentType
            );
            setPendingDecisionStatus(status);
            return status;
        } catch (e) {
            console.warn('Failed to load pending decision status', e);
            return null;
        }
    };

    useEffect(() => {
        if (client?.caseId && token) {
            refreshPendingDecisionStatus('TaxInvoice');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client?.caseId, token]);

    // Reference series per modal index of InvoiceModalTypes. These indices are not the
    // CreateInvoice modal types: here 1 is the credit note and 4 the transaction account.
    const documentTypeFromModalIndex = (index) => {
        if (index === 5 || index === 7) return 'ReceiptTax';
        if (index === 1) return 'CreditNote';
        if (index === 4) return 'Transaction';
        return 'TaxInvoice';
    };

    const ensureNoPendingDecisionTxDocs = async (mergedData, resumeKind) => {
        const actionValue = mergedData?.pendingAction?.value;
        const mapEntry = ACTION_TO_TYPE_INDEX[actionValue];
        if (!mapEntry || !MODAL_INDICES_TAX_AUTHORITY.includes(mapEntry.index)) return true;
        const caseId = mergedData?.documentInfo?.caseId || client?.caseId;
        if (!caseId || !token) return true;
        try {
            const status = await TaxAuthorityService.getPendingInvoiceDecisionStatus(
                caseId,
                token,
                documentTypeFromModalIndex(mapEntry.index)
            );
            setPendingDecisionStatus(status);
            if (status?.requiresDecision || status?.RequiresDecision) {
                setPendingMergedDataForTaxError(mergedData);
                setResolvePendingMode(true);
                setPendingResumeKind(resumeKind);
                setIsTaxAuthorityErrorModalVisible(true);
                return false;
            }
            return true;
        } catch (e) {
            console.warn('Pending decision check failed; continuing', e);
            return true;
        }
    };
    // Also store the mergedData you tried to generate before the user had to auth:
    const [pendingDocData, setPendingDocData] = useState(null);
    const [mergedBlobUrl, setMergedBlobUrl] = useState(null);   // objectURL of merged PDF
    const [mergeMenuAnchorEl, setMergeMenuAnchorEl] = useState(null); // anchor for "download as one file" original/copy choice
    const printComponentRef = useRef(null);

    const triggerPrint = useReactToPrint({
        content: () => printComponentRef.current,
        documentTitle: 'MergedDocuments',
        onAfterPrint: () => {
            URL.revokeObjectURL(mergedBlobUrl);
            setMergedBlobUrl(null);
        },
    });
    // --------------
    //  handleTaxAuthorityAuth
    // --------------
    const handleTaxAuthorityAuth = (authUrl, docData) => {
        // Save docData so we can resume after user completes auth
        setPendingDocData(docData);

        // Open the authentication URL in a new window
        const width = 600;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        const authWindow = window.open(
            authUrl,
            '_blank',
            `width=${width},height=${height},left=${left},top=${top}`
        );

        checkAuthCompletion(authWindow);
    };

    useEffect(() => {
        if (resumeInvoiceCreation && pendingDocData) {
            // The user finished tax authority auth
            // We proceed with final creation
            handleGenerateNewDoc(pendingDocData, true);
            // Reset after finishing
            setResumeInvoiceCreation(false);
        }
    }, [resumeInvoiceCreation, pendingDocData]);

    const checkAuthCompletion = async (authWindow) => {
        setLocalLoading(true);
        try {
            let attempts = 0;
            const maxAttempts = 25;
            while (attempts < maxAttempts) {
                if (authWindow.closed) {
                    setLocalLoading(false);
                    toast.error(t('Authentication window was closed by the user.'));
                    return;
                }

                const result = await TaxAuthorityService.checkAuthCompletionClient(client.caseId, Constants.TaxAuthorityScopes.CreationNumber);
                if (result.completed) {
                    setLocalLoading(false);
                    toast.success(t('TaxAuthorityAuthenticationComplete'));
                    // If we stored data in pendingDocData, now we can resume
                    setResumeInvoiceCreation(true);
                    authWindow.close();
                    return;
                }
                attempts++;
                await new Promise((res) => setTimeout(res, 3000));
            }
            // Timed out
            setLocalLoading(false);
            toast.error(t('tokenFetchError'));
            if (authWindow && !authWindow.closed) authWindow.close();
        } catch (error) {
            console.error('Error checking auth completion:', error);
            setLocalLoading(false);
            toast.error(t('tokenFetchError'));
            if (authWindow && !authWindow.closed) authWindow.close();
        }
    };

    // -----------------------------------------------------
    // 3) States for draft/final PDF modals
    // -----------------------------------------------------
    const [draftPdfModalVisible, setDraftPdfModalVisible] = useState(false);
    const [PdfModalVisible, setPdfModalVisible] = useState(false);
    const [draftPdfBlobs, setDraftPdfBlobs] = useState([]);
    const [finalPdfBlobs, setFinalPdfBlobs] = useState([]);
    const [sourcePreviewIndex, setSourcePreviewIndex] = useState(0);

    const multiSourcePreviewDocs = useMemo(() => {
        const fromPending = pendingDocData?.documentInfo?.sourceDocuments;
        if (fromPending?.length > 1) return fromPending;
        if (sourceDocs?.length > 1) return sourceDocs;
        if (currentDoc?.sourceDocuments?.length > 1) return currentDoc.sourceDocuments;
        return currentDoc ? [currentDoc] : [];
    }, [pendingDocData, sourceDocs, currentDoc]);

    const isMultiSourcePreview = multiSourcePreviewDocs.length > 1;

    const multiSourcePreviewLabelKey = useMemo(() => {
        if (!isMultiSourcePreview) return 'SourceDocuments';
        const sourceType = Number(multiSourcePreviewDocs[0]?.transactionDocumentType);
        if (sourceType === 1) return 'SourceQuotations';
        if (sourceType === 2) return 'SourceOrders';
        if (sourceType === 3) return 'SourceTransactionAccounts';
        if (sourceType === 4) return 'SourceInvoices';
        if (sourceType === 11) return 'SourceDeliveryNotes';
        return 'SourceDocuments';
    }, [isMultiSourcePreview, multiSourcePreviewDocs]);

    const currentSourcePreviewDoc = multiSourcePreviewDocs[sourcePreviewIndex]
        ?? multiSourcePreviewDocs[0]
        ?? currentDoc;

    useEffect(() => {
        if (draftPdfModalVisible || PdfModalVisible) {
            setSourcePreviewIndex(0);
        }
    }, [draftPdfModalVisible, PdfModalVisible]);

    const renderMultiSourcePreviewPanel = (width = '45%') => (
        <div
            style={{
                width,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid #ccc',
                borderRadius: 8,
                overflow: 'hidden',
                background: '#fff',
            }}
        >
            {isMultiSourcePreview && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 8,
                        padding: '8px 12px',
                        borderBottom: '1px solid #E0E0E0',
                        backgroundColor: '#F5F7FF',
                        flexWrap: 'wrap',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <Typography variant="body2" fontWeight={600}>
                            {t(multiSourcePreviewLabelKey)}
                        </Typography>
                        {multiSourcePreviewDocs.map((sourceDoc, index) => (
                            <Chip
                                key={sourceDoc.id ?? index}
                                size="small"
                                label={sourceDoc.reference || index + 1}
                                color={sourcePreviewIndex === index ? 'primary' : 'default'}
                                variant={sourcePreviewIndex === index ? 'filled' : 'outlined'}
                                onClick={() => setSourcePreviewIndex(index)}
                                sx={{ cursor: 'pointer' }}
                            />
                        ))}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <IconButton
                            size="small"
                            disabled={sourcePreviewIndex <= 0}
                            onClick={() => setSourcePreviewIndex((i) => Math.max(0, i - 1))}
                        >
                            <ArrowBackIcon sx={{ color: '#304FFF' }} />
                        </IconButton>
                        <Typography variant="caption">
                            {sourcePreviewIndex + 1} / {multiSourcePreviewDocs.length}
                        </Typography>
                        <IconButton
                            size="small"
                            disabled={sourcePreviewIndex >= multiSourcePreviewDocs.length - 1}
                            onClick={() => setSourcePreviewIndex((i) =>
                                Math.min(multiSourcePreviewDocs.length - 1, i + 1)
                            )}
                        >
                            <ArrowForwardIcon sx={{ color: '#304FFF' }} />
                        </IconButton>
                    </div>
                </div>
            )}
            <iframe
                src={currentSourcePreviewDoc?.documentUrl
                    ? `${currentSourcePreviewDoc.documentUrl}#page=1`
                    : undefined}
                width="100%"
                height="100%"
                style={{ border: 'none', flex: 1 }}
                aria-label={isMultiSourcePreview
                    ? `${t(multiSourcePreviewLabelKey)} ${currentSourcePreviewDoc?.reference || sourcePreviewIndex + 1}`
                    : 'Source Document PDF'}
            />
        </div>
    );

    const handleOpenSpecificInvoiceCreator = (type) => {
        if (type === 'LawyerInvoice' || type === 'LawyerReceipt') {
            viewDocumentCreate("/CreateLawyerInvoice", type);
        } else {
            viewDocumentCreate("/CreateInvoice", type);
        }
    };

    const handleOpenSpecificReceiptCreator = (type) => {
        if (type === 'LawyerReceipt') {
            viewDocumentCreate("/CreateLawyerInvoice", type);
        } else {
            viewDocumentCreate("/ReceiptTax", type);
        }
    };



    const TransactionDocumentsEnum = [
        { value: 1, label: "הצעת מחיר" },
        { value: 2, label: "הזמנה" },
        { value: 3, label: "חשבון עסקה" },
        { value: 4, label: "חשבונית מס" },
        { value: 5, label: "חשבונית מס זיכוי" },
        { value: 6, label: 'חשבונית מס קבלה' },
        { value: 7, label: 'קבלה' },
        { value: 8, label: "משיכה/הפקדה" },
        { value: 9, label: "קבלת דחויים" },
        { value: 10, label: "שיק מודפס" },
        { value: 11, label: "תעודת משלוח" },
        { value: 12, label: "תעודת החזרה" },
        { value: 13, label: "יציאת מלאי" },
        { value: 14, label: "כניסת מלאי" },
    ];

    const handleSignatureChange = () => {
        if (sigPad.current) {
            const signatureImage = sigPad.current.getTrimmedCanvas().toDataURL('image/png');
            setInvoiceSignature(signatureImage);
            setClient(prevClient => ({
                ...prevClient,
                signature: signatureImage
            }));
        }
    };

    const clearSignature = () => {
        if (sigPad.current) {
            sigPad.current.clear();
            setInvoiceSignature("");
        }
    };
    // Add a new item
    const handleAddItem = () => {
        const newItem = { makat: '', name: '', quantity: 1, price: null, discount: 0 };
        setInvoiceItems([...invoiceItems, newItem]);
    };

    const handleCloseAddItem = (index) => {
        const updatedFlags = [...addItemFlags];
        updatedFlags[index] = false;
        setAddItemFlags(updatedFlags);
    };

    // Update an existing item
    const handleItemChange = (index, field, value) => {
        if (addItemFlags[index]) {
            setNewItems(prevNewItems => {
                const newItemsCopy = [...prevNewItems];
                newItemsCopy[index] = {
                    ...newItemsCopy[index],
                    [field]: value,
                    caseId: client.caseId // Assuming caseId is available here
                };
                return newItemsCopy;
            });
        }
        if (field === "discount" && (parseInt(value) > 100 || parseInt(value) < 0)) {
            return;
        }
        setInvoiceItems(prevItems => {
            const updatedItems = prevItems.map((item, idx) => idx === index ? { ...item, [field]: value } : item);
            return updatedItems;
        });
    };


    // Remove an item
    const handleRemoveItem = (index) => {
        const newItems = invoiceItems.filter((_, idx) => idx !== index);
        setInvoiceItems(newItems);
    };


    const CloseReportingMonth = async (status) => {
        setLocalLoading(true);

        try {
            const response = await ClientService.UpdateReportingMonth(client.caseId, sortDate, status, token);
            if (response.ok) {
                toast.success({
                    text1: status ? t('MonthReportClosedSuccess') : t('MonthReportOpenedSuccess'),
                });
                dispatch(setTransactionMonthClosed(status))
            } else {
                const errorText = await response.text();
                console.error(t('MonthReportNotClosed'), errorText);
                toast.error({
                    text1: status ? `${t('MonthReportNotClosed')}: ${errorText}` : `${t('MonthReportNotOpened')}: ${errorText}`,
                });
            }
        } catch (error) {
            console.error(t('MonthReportNotClosed'), error);
            toast.error({
                text1: status ? `${t('MonthReportNotClosed')}: ${error}` : `${t('MonthReportNotOpened')}: ${error}`,
            });
        } finally {
            setLocalLoading(false); // Stop loading regardless of the outcome
            setIsModalVisible(false)
        }
    };

    const handleDeleteClick = (itemId) => {
        setItemIdToDelete(itemId);
        setIsModalVisible(true);
    };

    const handleDoneClick = async (itemId) => {
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleNotDoneClick = async (itemId) => {
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const toUtcMonthStart = (date) =>
        new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0));

    const toUtcMonthEnd = (date) =>
        new Date(Date.UTC(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999));



    const handleDateChangeNew = async (newValue, datePart) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (datePart === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), sortDate.getMonth(), 10));
        } else if (datePart === 'month') {
            updatedDate = new Date(Date.UTC(sortDate.getFullYear(), newDate.getMonth(), 10));
        }

        setSortDate(updatedDate);
        localStorage.setItem('Date', updatedDate);
        await fetchDocuments(updatedDate);
    };

    const handleStartDateChangeNew = async (newValue, datePart) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (datePart === 'year') {
            updatedDate = toUtcMonthStart(new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 1)));
        } else if (datePart === 'month') {
            updatedDate = toUtcMonthStart(new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 1)));
        }

        localStorage.setItem('StartDate', updatedDate);
        setStartDate(updatedDate);
        if (isRange) {
            await fetchDataOnDateRangeChange(new Date(updatedDate), new Date(endDate));
        }
    };

    const handleEndDateChangeNew = async (newValue, datePart) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (datePart === 'year') {
            updatedDate = toUtcMonthEnd(new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth(), 1)));
        } else if (datePart === 'month') {
            updatedDate = toUtcMonthEnd(new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth(), 1)));
        }

        localStorage.setItem('EndDate', updatedDate);
        setEndDate(updatedDate);
        if (isRange) {
            await fetchDataOnDateRangeChange(new Date(startDate), new Date(updatedDate));
        }
    };

    const handleDownloadStartDateChange = (date) => {
        const newDate = toUtcMonthStart(date);
        setDownloadStartDate(newDate);
    };

    const handleDownloadEndDateChange = async (date) => {
        const endDate = toUtcMonthEnd(date);
        setDownloadEndDate(endDate);
    };


    const fetchExactDocumentDates = useCallback(async (from, to, { backgroundRefresh, checkMonthClosed } = {}) => {
        if (!client?.caseId || !token) return;
        if (docFetchInFlightRef.current) return;
        const start = from || to;
        const end = to || from;
        if (!start || !end) return;
        docFetchInFlightRef.current = true;
        try {
            await dispatch(fetchTransactionDocumentPageData({
                type,
                caseId: client.caseId,
                startDate: toUtcDayStart(start).toISOString(),
                endDate: toUtcDayEnd(end).toISOString(),
                isRange: true,
                exactDocumentDates: true,
                checkMonthClosed: checkMonthClosed !== false && !isRangeRef.current,
                token,
                backgroundRefresh,
            })).unwrap();
        } catch (error) {
            if (!backgroundRefresh) toast.error(t('documentFetchError', { errorText: error }));
        } finally {
            docFetchInFlightRef.current = false;
        }
    }, [dispatch, type, client?.caseId, token, t]);

    const fetchDataOnDateRangeChange = useCallback(async (rangeStart, rangeEnd, { backgroundRefresh } = {}) => {
        if (filterByDocumentDateRef.current) {
            await fetchExactDocumentDates(
                documentDayStartRef.current || rangeStart,
                documentDayEndRef.current || rangeEnd,
                { backgroundRefresh, checkMonthClosed: false }
            );
            return;
        }
        if (docFetchInFlightRef.current) return;
        docFetchInFlightRef.current = true;
        try {
            await dispatch(fetchTransactionDocumentPageData({
                type, caseId: client.caseId,
                startDate: rangeStart.toISOString(),
                endDate: rangeEnd.toISOString(),
                isRange: true, token, backgroundRefresh,
            })).unwrap();
        } catch (error) {
            if (!backgroundRefresh) toast.error(t('documentFetchError', { errorText: error }));
        } finally {
            docFetchInFlightRef.current = false;
        }
    }, [dispatch, type, client?.caseId, token, t, fetchExactDocumentDates]);

    const handleConfirm = async () => {
        if (actionType === 'delete') {
            await handleConfirmDelete();
        } else if (actionType === 'closeMonth') {
            await CloseReportingMonth(true);
        } else if (actionType === 'openMonth') {
            await CloseReportingMonth(false);
        }
    };

    const getConfirmMessage = () => {
        switch (actionType) {
            case 'closeMonth':
                return t('AreYouSureCloseMonth');
            case 'openMonth':
                return t('AreYouSureOpenMonth');
            default:
                return t('confirmDeleteMessage');

        }
    };

    const getTitleMessage = () => {
        switch (actionType) {

            case 'closeMonth':
                return t('ConfirmCloseMonth');
            case 'openMonth':
                return t('ConfirmOpenMonth');
            default:
                return t('confirmDeleteTitle');
        }
    };

    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLocalLoading(true);
        try {
            const response = await DocumentService.DeleteDocument(type, itemIdToDelete, token);
            if (response.ok) {
                if (isRange) {
                    await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate))
                }
                else
                    await fetchDocuments(new Date(sortDate));

                // Show success toast
                toast.success(t("documentDeleteSuccess"));
            } else {
                // Handle any errors or display an error toast
                const errorResponse = await response.json();
                console.error('Error deleting document:', errorResponse);

                // Show error toast
                toast.error(t("documentDeleteError"));
            }
        } catch (error) {
            console.error('Error deleting document:', error);

            // Show error toast
            toast.error(t("documentDeleteError"));
        }
        setIsModalVisible(false);
        setLocalLoading(false);
    };

    // Document type mapping function using InvoiceModalTypes logic
    const getDocumentTypeFromTransactionType = (transactionDocumentType) => {
        // Map transaction document types to backend document types using InvoiceModalTypes logic
        switch (transactionDocumentType) {
            case 1: // Quotation
            case 2: // Order  
            case 3: // Transaction
                return 'TransactionDocument';
            case 4: // Invoice
            case 5: // Credit Invoice
                return 'Income';
            case 6: // Invoice Receipt
            case 7: // Receipt
            case 8: // Cancel Receipt
                return 'PaymentAcceptance';
            default:
                return 'TransactionDocument';
        }
    };

    const handleDownloadDocument = async (row, downloadType = 'copy') => {
        try {
            const documentType = getDocumentTypeFromTransactionType(row.transactionDocumentType);
            
            const dto = {
                CaseId: client.caseId,
                Id: row.id,
                DocumentType: documentType,
                DownloadOriginal: downloadType === 'original'
            };

            const blob = await DocumentService.DownloadDocument(token, dto);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            
            // Set appropriate filename based on download type
            let filename = `${row.reference || 'document'}`;
            if (downloadType === 'original') {
                filename += '_original.pdf';
            } else {
                filename += '_copy.pdf';
            }
            
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            toast.success(t('documentDownloadSuccess'));
        } catch (error) {
            console.error('Error downloading document:', error);
            toast.error(t('documentDownloadError'));
        }
    };

    /** Download the ORIGINAL file of each selected row. Single row => direct file, multiple => zip. */
    const handleBulkDownloadOriginals = async () => {
        const rows = filteredAndSortedData.filter((r) => selectionModel.includes(r.id));
        if (rows.length === 0) {
            toast.info(t('NoDocumentsFound'));
            return;
        }

        setLocalLoading(true);
        try {
            const fetchOriginal = async (row) => {
                const documentType = getDocumentTypeFromTransactionType(row.transactionDocumentType);
                const dto = {
                    CaseId: client.caseId,
                    Id: row.id,
                    DocumentType: documentType,
                    DownloadOriginal: true,
                };
                const blob = await DocumentService.DownloadDocument(token, dto);
                return { blob, name: `${row.reference || row.id}_original.pdf` };
            };

            // Single selection: download the file directly (no zip wrapper).
            if (rows.length === 1) {
                const { blob, name } = await fetchOriginal(rows[0]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
                toast.success(t('DocumentsDownloaded'));
                return;
            }

            // Multiple selection: batch originals into a single zip.
            const zip = new JSZip();
            let added = 0;
            await Promise.all(
                rows.map(async (row, index) => {
                    try {
                        const { blob, name } = await fetchOriginal(row);
                        zip.file(`${index + 1}_${name}`, blob);
                        added += 1;
                    } catch (err) {
                        console.error(`Error downloading original for row ${row.id}:`, err);
                    }
                })
            );

            if (added === 0) {
                toast.error(t('NoDocumentsFound'));
                return;
            }

            const zipBlob = await zip.generateAsync({ type: 'blob' });
            const url = URL.createObjectURL(zipBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `original_documents_${new Date().getTime()}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(url), 100);
            toast.success(t('DocumentsDownloaded'));
        } catch (error) {
            console.error('Error downloading originals:', error);
            toast.error(t('MergeOrPrintFailed'));
        } finally {
            setLocalLoading(false);
        }
    };

    /**
     * Merge the selected rows' documents into a single PDF and download it.
     * @param {'copy'|'original'} downloadType - which version of each document to merge.
     */
    const handleBulkDownloadMerged = async (downloadType = 'copy') => {
        const rows = filteredAndSortedData.filter((r) => selectionModel.includes(r.id));
        if (rows.length === 0) {
            toast.info(t('NoDocumentsFound'));
            return;
        }

        setLocalLoading(true);
        try {
            // For originals, fetch the source file per row from the backend.
            const fetchOriginalBytes = async (row) => {
                const documentType = getDocumentTypeFromTransactionType(row.transactionDocumentType);
                const dto = {
                    CaseId: client.caseId,
                    Id: row.id,
                    DocumentType: documentType,
                    DownloadOriginal: true,
                };
                const blob = await DocumentService.DownloadDocument(token, dto);
                return await blob.arrayBuffer();
            };

            const merged = await PDFDocument.create();

            if (downloadType === 'original') {
                for (const row of rows) {
                    try {
                        const bytes = await fetchOriginalBytes(row);
                        const srcPdf = await PDFDocument.load(bytes);
                        const pages = await merged.copyPages(srcPdf, srcPdf.getPageIndices());
                        pages.forEach((p) => merged.addPage(p));
                    } catch (err) {
                        console.error(`Error loading original PDF for row ${row.id}:`, err);
                    }
                }
            } else {
                const validRows = rows.filter((r) => r.documentUrl && r.documentUrl !== NoDocumentsPdf);
                if (validRows.length === 0) {
                    toast.info(t('NoDocumentsFound'));
                    return;
                }
                for (const row of validRows) {
                    try {
                        const bytes = await fetch(row.documentUrl).then((r) => r.arrayBuffer());
                        const srcPdf = await PDFDocument.load(bytes);
                        const pages = await merged.copyPages(srcPdf, srcPdf.getPageIndices());
                        pages.forEach((p) => merged.addPage(p));
                    } catch (err) {
                        console.error(`Error loading PDF from ${row.documentUrl}:`, err);
                    }
                }
            }

            if (merged.getPageCount() === 0) {
                toast.error(t('NoDocumentsFound'));
                return;
            }

            const mergedPdfBytes = await merged.save();
            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            const suffix = downloadType === 'original' ? 'original' : 'copy';
            link.download = `merged_documents_${suffix}_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
            toast.success(t('DocumentsDownloaded'));
        } catch (error) {
            console.error('Error merging/downloading documents:', error);
            toast.error(t('MergeOrPrintFailed'));
        } finally {
            setLocalLoading(false);
        }
    };

    const handleEdit = (item) => {
        setEditingRow(item.id);
        setEditedItem({ ...item }); // create a copy of the item for editing
        let statusChecked = type == "Incomes" ? client.documentIds.incomes.includes(item.id) : client.documentIds.expenses.includes(item.id);
        setStautsCheck(!statusChecked);
    };

    


    const handleRadioChange = (e) => {
        if (e.target.value == 'done') {

            if (!editedItem.sortCodeId) {
                toast.error();
                return
            }
            setStautsCheck(true);
        }
        else if (e.target.value == 'notDone') {
            setStautsCheck(false);
        }
        setEditedItem({ ...editedItem, ["status"]: e.target.value });
    };
    const handleVatRadioChange = (e) => {
        setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
    };
    const handleDateChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e });
    };
    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        if (response1.ok) {
            const isClosedReportingMonth = await response1.json();
            if (isClosedReportingMonth) {
                toast.info(t('MonthReportAlreadyClosedTryAgain'));
                return;
            }
            else {
                setEditedItem({ ...editedItem, [field]: newDate });
            }
        }
    }

    const handleChangeNew = (selectedOption) => {
        if (selectedOption.value1 === "AddItem") {
            setCreditAccountOption("");
            setDebitAccountOption("");
            setAccountCodeName("");
            setAccountCodeId("");
            setCompanyId("");
            setAddNewAccountCardDocument(true);
        }
        else {
            setAccountCodeName(selectedOption.value);
            setCompanyId(selectedOption.accountCaseId);
            const accountCard = accountCardOptions.find(option => option.name === selectedOption.value);
            setAccountCodeId(accountCard.cardId);
            type === 'Incomes' ? setDebitAccountOption(accountCard.cardId) : setCreditAccountOption(accountCard.cardId)
        }
    };

    const handleInvoiceAccount = (selectedOption) => {

        if (selectedOption.value1 === 'AddItem') {
            setAddNewAccountCard(true);
        } else {
            setInvoiceClientName(selectedOption.value);
            const accountCard = accountCardOptions.find(option => option.name === selectedOption.value);
            setInvoiceAccountCodeId(accountCard.cardId);
        }
    };

    const handleInvoiceItem = (index, selectedOption) => {
        if (selectedOption.value === 'add-item') {
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = true;
            setAddItemFlags(updatedFlags);
        } else {
            const accountCard = clientItems.find(option => option.makat === selectedOption.value);
            handleItemChange(index, 'makat', accountCard.makat);
            handleItemChange(index, 'name', accountCard.name);
            // Reset flag in case it was set
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = false;
            setAddItemFlags(updatedFlags);
        }
    };

    const handleUpdate = async (itemId) => {
        setLocalLoading(true);
        try {
            delete editedItem.documentUrl;
            const response = await DocumentService.UpdateDocument(type, token, editedItem);
            if (editedItem.status == 'done') {
                await handleDoneClick(editedItem.id);
                handleSortChange('id', 'newest', 'descending');
            }
            else if (editedItem.status == 'notDone') {
                await handleNotDoneClick(editedItem.id)
            }

            if (editedAddAccountCard) {
                await handleAccountCardSave(editedItem.accountCodeId, editedItem.accountCodeName, editedItem.accountCaseId);
                await fetchEnums(token, client)
            }

            if (response.ok) {
                if (isRange) {
                    await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate))
                }
                else
                    await fetchDocuments(new Date(sortDate));
                // Show success toast
                toast.success(t("documentUpdateSuccess"));
            } else {
                const errorText = await response.text();
                // Handle error

                // Show error toast
                toast.error(t("documentUpdateError"));
            }
        } catch (error) {
            // Handle error

            // Show error toast
            toast.error(t("documentUpdateError"));
        }
        setEditingRow(null);
        setEditedItem({});
        setEditedAddAccountCard(false);
        setLocalLoading(false);
        // Refresh or update your data list
    };


    const handleCancel = () => {
        setEditingRow(null);
        setEditedItem({});
        setEditedAddAccountCard(false);
    };


    const handleDocumentUpload = (event) => {
        setDocuments(Array.from(event.target.files));
    };

    const formatDate = dateString => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleDownloadIncomeSummary = () => {
        const rows = (filteredAndSortedData || []).filter((row) =>
            INCOME_SUMMARY_TYPES.includes(Number(row.transactionDocumentType)) && !row.isCanceled
        );
        if (rows.length === 0) {
            toast.info(t('NoDataToDownload'));
            return;
        }

        const roundMoney = (value) => Math.round((Number(value) || 0) * 100) / 100;
        const typeLabel = (typeValue) => Constants.TransactionDocuments[typeValue] || '';
        const sumBy = (group, field) => roundMoney(group.reduce((sum, row) => sum + (Number(row[field]) || 0), 0));

        const details = rows.map((row) => ({
            [t('DocumentType')]: typeLabel(row.transactionDocumentType),
            [t('DocumentDate')]: row.documentDate ? formatDate(row.documentDate) : '',
            [t('Client Name')]: row.accountCodeName || '',
            [t('CompanyId')]: row.accountCaseId || '',
            [t('Reference')]: row.reference || '',
            [t('Description')]: row.description || '',
            [t('PaymentMethod')]: (row.paymentMethods || row.PaymentMethods || []).map(paymentMethodLabel).join(', '),
            [t('NetAmount')]: roundMoney(row.netAmount),
            [t('VATAmount')]: roundMoney(row.vatAmount),
            [t('Amount')]: roundMoney(row.amount),
            [t('WithholdingTax')]: roundMoney(row.withholdingTax),
        }));

        const summaryRows = INCOME_SUMMARY_TYPES.map((typeValue) => {
            const group = rows.filter((row) => Number(row.transactionDocumentType) === typeValue);
            return {
                [t('DocumentType')]: typeLabel(typeValue),
                [t('Count')]: group.length,
                [t('NetAmount')]: sumBy(group, 'netAmount'),
                [t('VATAmount')]: sumBy(group, 'vatAmount'),
                [t('Amount')]: sumBy(group, 'amount'),
            };
        });
        summaryRows.push({
            [t('DocumentType')]: t('GrandTotal'),
            [t('Count')]: rows.length,
            [t('NetAmount')]: sumBy(rows, 'netAmount'),
            [t('VATAmount')]: sumBy(rows, 'vatAmount'),
            [t('Amount')]: sumBy(rows, 'amount'),
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(summaryRows), String(t('IncomeSummary')).slice(0, 31));
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(details), String(t('IncomeSummaryDetails')).slice(0, 31));
        const dateStr = new Date().toISOString().split('T')[0];
        XLSX.writeFile(workbook, `IncomeSummary-${client?.caseId || 'documents'}-${dateStr}.xlsx`);
        toast.success(t('ExcelFileDownloadedSuccessfully'));
    };


    const closeCreateModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (modalCreateDocumentRef.current && !modalCreateDocumentRef.current.contains(e.target)) {
            handleClose();
        }
    }

    const closeCreateInvoiceModal = (e) => {
        // DocumentChoiceModal handles its own overlay clicks, so we can just close directly
        handleInvoiceClose();
    }
    const closeSignatureInvoiceModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (signatureReferenceInvoiceModalVisibleRef.current && !signatureReferenceInvoiceModalVisibleRef.current.contains(e.target)) {
            handleSignatureReferenceClose();
        }
    }
    const handleClose = async () => {
        setModalVisible(false);
        setErrorMessage('');
        setOkMessage('');
        setDocumentCost("");
        setDocumentReference("")
        setCodeId("")
        setAccountCodeName("")
        setCreditAccountOption("")
        setDebitAccountOption("")
        setDescription("")
    }

    const handleInvoiceClose = async () => {
        setInvoiceDescription('');
        setInvoiceClientName('');
        setInvoiceClientCaseId('');
        setInvoiceClientLocation('');
        setInvoiceClientEmail('');
        setInvoiceAccountCodeId('');
        setInvoiceClientPhoneNumber('');
        setInvoiceItems([]);
        setInvoiceDate(new Date());
        setInvoiceSignature('');
        setInvoiceReference('');
        setAddNewAccountCard('');
        setPriceIncludingVAT(false);
        setInvoiceModalVisible(false);
        setInvoiceModalChoiceVisible(false);
        setInvoiceModalChoiceSpecificVisible(false);
    }

    const [clientSignatureNeeded, setClientSignatureNeeded] = useState(false);

    const handleSignatureReferenceClose = async () => {
        setInvoiceSignature('');
        setInvoiceReference('');
        setSignatureReferenceInvoiceModalVisible(false);
    }
    // new sign
    const handleSignatureReferenceSave = async () => {
        setSignatureReferenceInvoiceModalVisible(false);
        const updatedClient = {
            ...client,
            signature: invoiceSignature
        };
        setClient(updatedClient);


        setAddNewSignatureReference(true);
        setInvoiceModalVisible(true);
    }
    // const allFieldsFilled = sortCodeId && documentReference && documentCost && documentDate && creditAccountOption && debitAccountOption && accountCodeName && accountCodeId && description && photo
    const allFieldsFilled = true;


    const signatureReferenceFilled = (invoiceSignature && invoiceReference && clientSignatureNeeded) || (invoiceReference && !clientSignatureNeeded);


    const allClientItemFieldsFilled = invoiceClientName && invoiceClientCaseId && invoiceItems && invoiceItems.length > 0 && invoiceItems.every(item => {
        const hasRequiredFields = item.name && item.makat && item.price && item.discount >= 0; // Check if name, makat, and price are provided
        item.quantity = item.quantity || 1; // Default quantity to 1 if not provided
        item.discount = item.discount || 0; // Default discount to 1 if not provided
        return hasRequiredFields;
    });

    const handleSave = async () => {
        if (documents && documents.length > 0 && autoFilling) {
            handleOCRSave();
        } else {
            handleNormalSave();
        }
    };


    const handleNormalSave = async () => {
        if (!allFieldsFilled) {
            setErrorMessage(t('errorFieldsNotFilled'));
            return; // Stop execution if fields are not filled
        }
        setLocalLoading(true);

        const formData = new FormData();
        formData.append('CaseId', client.caseId);
        formData.append('AccountantId', user.accountantId);
        formData.append('SortCodeId', sortCodeId)
        formData.append('Reference', documentReference)
        formData.append('Amount', documentCost);
        formData.append('DocumentDate', new Date(documentDate).toISOString());
        formData.append('ReportingMonthDate', new Date(sortDate).toISOString());
        formData.append('CreditAccount', type !== 'Incomes' && !creditAccountOption ? accountCodeId : creditAccountOption);
        formData.append('DebitAccount', type === 'Incomes' && !debitAccountOption ? accountCodeId : debitAccountOption);
        formData.append('AccountCodeName', accountCodeName);
        formData.append('AccountCodeId', accountCodeId);
        formData.append('AccountCaseId', companyId);
        documents.forEach(document => {
            formData.append("documents", document, document.name);
        });
        formData.append('DocumentType', type);
        formData.append('DocumentFileType', type);
        formData.append('Description', description)
        formData.append('VAT', documentVat)

        try {
            const response = await DocumentService.UploadDocument(type, formData, token);
            if (response.ok) {
                if (addNewAccountCardDocument) {
                    await handleAccountCardSave(accountCodeId, accountCodeName);
                    await fetchEnums(token, client);
                }
                toast.success(t('documentUploadSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentUploadError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentUploadError', { errorText: 'Error uploading document' }));
        }
        setModalVisible(false);
        setDocumentCost("");
        setDocumentReference("");
        setCodeId("");
        setAccountCodeName("");
        setAccountCodeId("");
        setCreditAccountOption("");
        setDebitAccountOption("");
        setDescription("");
        setDocuments([])
        setAddNewAccountCardDocument(false);
        await fetchDocuments(new Date(sortDate));
        await fetchDocumentsNotification(client, token)
        setLocalLoading(false);
    };



    const handleOCRSave = async () => {
        if (!allFieldsFilled) {
            setErrorMessage(t('errorFieldsNotFilled'));
            return; // Stop execution if fields are not filled
        }
        setLocalLoading(true);

        const formData = new FormData();
        formData.append('CaseId', client.caseId);
        formData.append('AccountantId', user.accountantId);
        formData.append('ReportingMonthDate', new Date(sortDate).toISOString());
        formData.append('DocumentFileType', type);
        formData.append('VAT', documentVat)
        documents.forEach(document => {
            formData.append("documents", document, document.name);
        });


        try {
            const response = await DocumentService.UploadOCRDocument(type, formData, token);
            if (response.ok) {
                toast.success(t('documentUploadSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentUploadError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentUploadError', { errorText: 'Error uploading document' }));
        }
        setModalVisible(false);
        setDocuments([])
        await fetchDocuments(new Date(sortDate));
        await fetchDocumentsNotification(client, token)
        await fetchEnums(token, client);
        setLocalLoading(false);
    };

    const updateLocationState = async (newClientData) => {

        const updatedClientData = {
            ...location.state.client,
            ...newClientData
        };

        // Navigate with the updated client data and replace the current state
        setIsFirstUserFetched(false);
        navigate(location.pathname, {
            replace: true,
            state: { client: updatedClientData, type, sortDate }
        });
    };

    const handleSaveSignature = async () => {
        // const response1 = await ClientService.UpdateClient(token, { invoiceSignature });
        // if (!response1.ok) {
        //     throw new Error(`HTTP error! status: ${response1.status}`);
        // }

        const Client = await ClientService.GetClient(token, client.caseId);
        updateLocationState(Client);

    }
    const handleAccountCardSave = async (AccountCodeId, AccountCodeName) => {
        let response2;
        if (type === 'Incomes') {
            const response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, companyId, "לקוחות", token);
        } else {
            const response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, companyId, "ספקים", token);
        }
        if (!response2.ok) {
            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };

    const saveNewItemsToDatabase = async () => {
        // Filter out undefined items
        const filteredItems = newItems.filter(item => item !== undefined);

        // Assuming EnumsService.AddClientItems expects an array of items
        const response = await EnumsService.AddClientItems(filteredItems, token);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Reset newItems after saving
        setNewItems([]);
        // Optionally reset addItemFlags if necessary
        setAddItemFlags([]);

        return response;
    };
    //Now


    const [accountant, setAccountant] = useState({});
    const [subAccountants, setSubAccountants] = useState([]);
    const [subAccountantOptions, setSubAccountantOptions] = useState([]);


    const fetchEnums = async (tkn, cl) => {
        try {
            const [codeIdResponse, accountsResponse, clientItemsResponse, subAccountantsResult, accountantResult] =
                await Promise.all([
                    EnumsService.GetSortCodesByAccountantId(cl.accountantId, tkn),
                    EnumsService.GetAccountCardsByCaseId(cl.caseId, tkn),
                    ClientItemsService.GetClientItemsByCaseId(cl.caseId, tkn),
                    SubAccountantService.GetSubAccountantByAccountantId(tkn, cl.accountantId),
                    SubAccountantService.GetAccountantById(tkn, cl.accountantId),
                ]);

            if (codeIdResponse.ok) {
                setSortCodeIdOptions(await codeIdResponse.json());
            }

            if (accountsResponse.ok) {
                const accountsData = await accountsResponse.json();
                setCreditAccountOptions(accountsData);
                setDebitAccountOptions(accountsData);
                setAccountCardEditDownloadOptions(accountsData);
                setAccountCardOptions([{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData]);
            }

            if (clientItemsResponse.ok) {
                const items = await clientItemsResponse.json();
                items.unshift({ makat: 'add-item', name: t('NewItem') });
                setClientItems(items);
            }

            const enhancedAccountantResult = {
                ...accountantResult,
                subAccountantId: accountantResult.accountantId,
            };
            setAccountant(enhancedAccountantResult);

            if (subAccountantsResult) {
                const combinedSubAccountants = [enhancedAccountantResult, ...subAccountantsResult];
                if (cl) {
                    combinedSubAccountants.push({ subAccountantId: cl.caseId, name: cl.name });
                }
                setSubAccountants(combinedSubAccountants);
                setSubAccountantOptions(combinedSubAccountants.map((acc) => ({
                    value: acc.subAccountantId,
                    label: acc.name,
                })));
            } else {
                toast.error(t('fetchSubAccountantsDataError'));
            }

            setIsFirstUserFetched(true);
        } catch (error) {
            console.error("Error fetching enum data:", error);
            toast.error(t('enumFetchError', { errorText: error.message }));
        }
    };


    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);

        // Enrich clients with their total document counts
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts.totalCounts || 0, // Default to 0 if no matching count is found
            documentCounts: documentCounts.documentCounts || {},
            documentIds: documentCounts.documentIds || {},
        };
        setInvoiceSignature(enrichedClient.signature);
        setClient(enrichedClient);
    }
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    if (location.state && location.state.client && location.state.type) {
                        const cl = location.state.client;
                        const tp = location.state.type;
                        const TaxExempt = Constants.TaxExemptTypes.includes(cl?.caseType);
                        setIsTaxExempt(TaxExempt);
                        setType(tp);

                        const selectedDate = isRange ? null : sortDate;
                        const dateForApi = selectedDate
                            ? new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10))
                            : null;
                        const documentDateFetch = filterByDocumentDate
                            ? {
                                isRange: true,
                                exactDocumentDates: true,
                                checkMonthClosed: !isRange,
                                date: undefined,
                                startDate: toUtcDayStart(isRange ? documentDayStart : documentDay).toISOString(),
                                endDate: toUtcDayEnd(isRange ? documentDayEnd : documentDay).toISOString(),
                            }
                            : {
                                isRange,
                                date: dateForApi,
                                startDate: isRange ? startDate.toISOString() : undefined,
                                endDate: isRange ? endDate.toISOString() : undefined,
                            };

                        initialFetchDoneRef.current = true;
                        await Promise.all([
                            fetchDocumentsNotification(cl, currentToken),
                            fetchEnums(currentToken, cl),
                            dispatch(fetchTransactionDocumentPageData({
                                type: tp,
                                caseId: cl.caseId,
                                token: currentToken,
                                ...documentDateFetch,
                            })).unwrap().catch(() => {}),
                            SelfIncomesService.HasSelfInvoices(cl.caseId, currentToken)
                                .then((res) => setHasSelfInvoices(Boolean(res?.hasSelfInvoices)))
                                .catch(() => setHasSelfInvoices(false)),
                        ]);
                    }
                } else {
                    navigate("/login");
                }
            } catch (error) {
                // Handle error
            }
        };

        fetchUserData();
    }, [location.state.client]);

    useEffect(() => {
        // To handle multiple updates efficiently, consider iterating over documentUpdate keys
        Object.keys(documentUpdate).forEach(updateCaseId => {
            const update = documentUpdate[updateCaseId];
            // Update clients with new totalCounts for the matching caseId

            if (client?.caseId === updateCaseId) { // Check if the client's caseId matches the update's caseId
                const updatedClients = {
                    ...client,
                    totalCounts: update.totalCounts, // Update totalCounts from documentUpdate
                    documentIds: update.documentsIds,
                    documentsCount: update.documentsCount
                };
                setClient(updatedClients); // Update the state with the modified lzist
            }

        });
    }, [documentUpdate]);

    const fetchDocuments = useCallback(async (selectedDate, { backgroundRefresh } = {}) => {
        if (filterByDocumentDateRef.current) {
            const from = isRangeRef.current
                ? (documentDayStartRef.current || selectedDate)
                : (documentDayRef.current || selectedDate);
            const to = isRangeRef.current
                ? (documentDayEndRef.current || selectedDate)
                : (documentDayRef.current || selectedDate);
            await fetchExactDocumentDates(from, to, { backgroundRefresh, checkMonthClosed: !isRangeRef.current });
            return;
        }
        if (docFetchInFlightRef.current) return;
        docFetchInFlightRef.current = true;
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        try {
            await dispatch(fetchTransactionDocumentPageData({
                type, caseId: client.caseId, date: newDate,
                isRange: false, token, backgroundRefresh,
            })).unwrap();
        } catch (error) {
            if (!backgroundRefresh) toast.error(t('documentFetchError', { errorText: error }));
        } finally {
            docFetchInFlightRef.current = false;
        }
    }, [dispatch, type, client?.caseId, token, t, fetchExactDocumentDates]);



    const handleDownloadDocuments = async () => {
        setLocalLoading(true);
        try {
            const dto = {
                CaseId: client.caseId,
                Date: downloadStartDate,
                EndDate: downloadEndDate,
                AccountCodeIds: downloadAccountCodeId,
                Amount: downloadAmount
            };

            const blob = await DocumentService.DownloadCustomDocuments(type, token, dto); // Assuming you have token state or prop for authorization
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'documents.zip'); // or any other extension
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success(t('documentDownloadSuccess'));
        } catch (error) {
            console.error('Error downloading documents:', error);
            toast.error(t('documentDownloadError', { errorText: error.message }));
        }
        setDownloadStartDate(null);
        setDownloadEndDate(null);
        setDownloadAmount();
        setDownloadAccountCodeId([]);
        setShowDownloadModal(false)
        setLocalLoading(false);
    };


    useEffect(() => {
        if (!isFirstUserFetched) return;
        if (initialFetchDoneRef.current) {
            initialFetchDoneRef.current = false;
            return;
        }
        if (!isRange)
            fetchDocuments(sortDate);
        else
            fetchDataOnDateRangeChange(startDate, endDate);
    }, [isFirstUserFetched]);

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <button className={`document-custom-input ${isRange ? "document-custom-input-range" : ""}`} onClick={onClick} ref={ref}>
            {value}
        </button>
    ));


    const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="document-custom-input1" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const CustomDownloadInput = React.forwardRef(({ value, placeholderText, onClick }, ref) => {
        return (
            <button className="download-document-custom-input" onClick={onClick} ref={ref}>
                {value || placeholderText}
            </button>
        );
    });


    const getMenuItemsByType = (type, isCanceled) => {
        const allActions = Constants.transactionDocumentActions[type] || [];

        /* drop cancel_* for rows already canceled */
        let actions = isCanceled
            ? allActions.filter(a => !a.value.startsWith('cancel_'))
            : [...allActions];

        /* tax-exempt ⇒ keep every cancel_* but only a short
           whitelist of generate_* actions                 */
        if (isTaxExempt) {
            actions = actions.filter(
                a =>
                    a.value.startsWith('cancel_') ||
                    ALLOWED_TAX_EXEMPT_GEN.includes(a.value)
            );
        }

        // Receipt / deferred receipt / deposit types: never offer generate ReceiptTax
        const docType = Number(type);
        if (docType === 7 || docType === 8 || docType === 9) {
            actions = actions.filter(a => a.value !== 'generate_invoice_receipt');
        }

        return actions;
    };
    const getRowActions = (row) => {
        if (!row) return [];

        // const blocked =
        //     row.isCanceled ||
        //     (row.description?.includes("ביטול חשבונית מס קבלה מספר") ||
        //         row.description?.includes("ביטול קבלה מספר"));

        const blocked =
            row.isCanceled;
        if (blocked) return [];
        let actions = getMenuItemsByType(row.transactionDocumentType, row.isCanceled);
        if (isConversionCancelBlocked(row, data)) {
            const cancelAction = Constants.CANCEL_ACTIONS1[row.transactionDocumentType];
            if (cancelAction?.value) {
                actions = actions.filter((a) => a.value !== cancelAction.value);
            }
        }
        if (getGroupedOpenInvoices(row, data).length > 1) {
            actions = [
                ...actions,
                { label: 'GenerateReceiptForGroupInvoices', value: GROUP_RECEIPT_GENERATE },
            ];
        }
        return actions;
    };

    const actuallySendEmail = async (rows, emails) => {
        setLocalLoading(true);
        const recipients = Array.isArray(emails) ? emails : [emails].filter(Boolean);
        const dto = {
            caseId: client.caseId,
            accountantId: client.accountantId,
            toEmails: recipients,
            DocumentIds: rows.map(r => r.id),
        };

        try {
            await DocumentService.BulkEmailDocuments(dto, token);
            toast.success(t("BulkEmailSent"));
        } catch (error) {
            console.error('Email sending failed:', error);
            toast.error(`${t("BulkEmailFailed")}: ${error.message}`);
        }
        setSelectedIds([]);
        setTargetEmails([]);
        setLocalLoading(false);

    };

    const actuallySendWhatsApp = async (rows, phones) => {
        setLocalLoading(true);
        const recipients = Array.isArray(phones) ? phones : [phones].filter(Boolean);
        const dto = {
            caseId: client.caseId,
            accountantId: client.accountantId,
            toPhones: recipients,
            DocumentIds: rows.map(r => r.id),
        };

        try {
            await DocumentService.BulkWhatsAppDocuments(dto, token);
            toast.success(t("BulkWhatsAppSent"));
        } catch (error) {
            console.error('WhatsApp sending failed:', error);
            toast.error(`${t("BulkWhatsAppFailed")}: ${error.message}`);
        }
        setSelectedIds([]);
        setTargetPhones([]);
        setLocalLoading(false);
    };




    const handleBulkAction = async (action, rowIds) => {

        const rows = filteredAndSortedData.filter(r => rowIds.includes(r.id));
        if (rows.length === 0) return;
        setSelectedIds(rowIds)

        try {
            setLocalLoading(true);

            switch (action) {
                /* ───────────────────────────  PRINT  ─────────────────────────── */
                case 'bulk_print': {
                    const urls = rows.map(r => r.documentUrl || NoDocumentsPdf);

                    try {
                        /* 1️⃣  merge */
                        const merged = await PDFDocument.create();
                        for (const url of urls) {
                            const bytes = await fetch(url).then(r => r.arrayBuffer());
                            const srcPdf = await PDFDocument.load(bytes);
                            const pages = await merged.copyPages(srcPdf, srcPdf.getPageIndices());
                            pages.forEach(p => merged.addPage(p));
                        }
                        const blob = new Blob([await merged.save()], { type: 'application/pdf' });
                        const blobUrl = URL.createObjectURL(blob);

                        /* 2️⃣  inject invisible iframe and print from inside it */
                        const iframe = document.createElement('iframe');
                        iframe.style.position = 'fixed';
                        iframe.style.right = '0';
                        iframe.style.bottom = '0';
                        iframe.style.width = '0';
                        iframe.style.height = '0';
                        iframe.style.border = 'none';
                        iframe.src = `${blobUrl}#zoom=100&toolbar=0&navpanes=0`;   // hide viewer UI

                        iframe.onload = () => {
                            try {
                                iframe.contentWindow.focus();
                                iframe.contentWindow.print();
                            } finally {
                                /* tidy up */
                                setTimeout(() => {
                                    URL.revokeObjectURL(blobUrl);
                                    document.body.removeChild(iframe);
                                }, 10_000);
                            }
                        };

                        document.body.appendChild(iframe);
                        toast.success(t('DocumentsOpenedForPrint'));
                    } catch (err) {
                        console.error(err);
                        toast.error(t('MergeOrPrintFailed'));
                    }
                    break;
                }



                /* ─────────────────────────── DOWNLOAD ────────────────────────── */
                case "bulk_download": {
                    const zip = new JSZip();

                    // fetch every PDF into the ZIP
                    await Promise.all(
                        rows.map(async (r, index) => {
                            const pdfResp = await fetch(r.documentUrl || NoDocumentsPdf);
                            const blob = await pdfResp.blob();
                            const name = `doc_${index + 1}.pdf`; // start from 1 instead of 0
                            zip.file(name, blob);
                        })
                    );

                    const zipBlob = await zip.generateAsync({ type: "blob" });
                    const url = URL.createObjectURL(zipBlob);

                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "documents.zip";
                    a.click();
                    URL.revokeObjectURL(url);

                    toast.success(t("DocumentsDownloaded"));
                    break;
                }

                /* ───────────────────────────  E‑MAIL  ────────────────────────── */
                case "bulk_email": {
                    setShowEmailModal(true);
                    break;
                }

                /* ─────────────────────────── WHATSAPP ────────────────────────── */
                case "bulk_whatsapp": {
                    setShowWhatsAppModal(true);
                    break;
                }

                default:
                    break;
            }
        } catch (err) {
            console.error("Bulk action error:", err);
            toast.error(t("OperationFailed"));
        } finally {
            setLocalLoading(false);
            setSelectionModel([]);      // optional – clear selection
        }
    };


    const handleSortCodeChange = (selectedOption) => {
        // Set the sortCodeId to the value from the selected option
        setCodeId(selectedOption.value);
        // Check for a number within parentheses
        const match = selectedOption.label.match(/\((\d+)\)/);
        let customVat = null;

        if (match) {
            customVat = parseInt(match[1], 10);
        }

        if (customVat != null) {
            if (customVat == '66') {
                let customVatFixed = 2 / 3;
                setDocumentVat(customVatFixed);
            } else {
                setDocumentVat(customVat);
            }
        } else {
            setDocumentVat(100);
        }
    };


    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction, type });
    };

    const makatFilterOptions = useMemo(() => {
        const seen = new Set();
        const options = [];
        (clientItems || []).forEach((item) => {
            const makat = item?.makat != null ? String(item.makat).trim() : '';
            if (!makat || makat === 'add-item' || makat === ROUNDING_MAKAT || seen.has(makat)) {
                return;
            }
            seen.add(makat);
            options.push({
                value: makat,
                label: item.name ? `${makat} - ${item.name}` : makat,
                makat,
                name: item.name || '',
                itemId: item.id,
            });
        });
        return options;
    }, [clientItems]);

    const clientFilterOptions = useMemo(() => (
        (accountCardEditDownloadOptions || [])
            .filter((option) => option?.cardId != null && option?.value1 !== 'AddItem')
            .map((option) => ({
                value: option.cardId,
                label: option.accountCaseId
                    ? `${option.name} - ${option.accountCaseId}`
                    : `${option.name || option.cardId}`,
            }))
    ), [accountCardEditDownloadOptions]);

    const documentStatusFilterOptions = useMemo(() => ([
        { value: 'open', label: t('DocumentStatusOpen') },
        { value: 'partial', label: t('DocumentStatusPartial') },
        { value: 'closed', label: t('DocumentStatusClosed') },
    ]), [t]);

    useEffect(() => {
        if (selectedMakats.length === 0) {
            setMakatMatchingDocIds(null);
            return;
        }
        if (!client?.caseId || !token) {
            setMakatMatchingDocIds(new Set());
            return;
        }

        let cancelled = false;
        const run = async () => {
            try {
                const selectedItemIds = makatFilterOptions
                    .filter((option) => selectedMakats.includes(option.value) && option.itemId)
                    .map((option) => option.itemId);
                const result = await DocumentService.GetDocumentIdsByMakats(
                    client.caseId,
                    selectedMakats,
                    selectedItemIds,
                    token
                );
                const ids = result?.documentIds || result?.DocumentIds || [];
                if (!cancelled) {
                    setMakatMatchingDocIds(new Set(ids.map((id) => String(id).toLowerCase())));
                }
            } catch (error) {
                console.error('Error filtering documents by makat:', error);
                if (!cancelled) {
                    setMakatMatchingDocIds(new Set());
                    toast.error(t('OperationFailed'));
                }
            }
        };
        run();
        return () => { cancelled = true; };
    }, [selectedMakats, client?.caseId, token, makatFilterOptions, t]);

    const filteredAndSortedData = useMemo(() => {
        if (data.length < 0) {
            return;
        }
        const sortedData = data.filter((item) => {
            const query = searchQuery.toLowerCase();
            const amountString = item?.amount?.toString(); // Safely access item.amount
            // Out-of-period rows are linked documents from other months, returned only to complete
            // a family. They are never standalone rows or counted in totals; the grid still shows
            // them nested with their in-period relatives (it builds the tree from `allDocuments`).
            if (item?.isOutOfPeriod) {
                return false;
            }
            if (
                documentTypes.length > 0 &&
                !documentTypes.includes(item.transactionDocumentType)
            ) {
                return false;
            }

            if (paymentMethods.length > 0) {
                if (Number(item.transactionDocumentType) !== INVOICE_RECEIPT_TYPE) {
                    return false;
                }
                const methods = item.paymentMethods || item.PaymentMethods || [];
                if (!methods.some((method) => paymentMethods.includes(method))) {
                    return false;
                }
            }

            if (selectedMakats.length > 0 && makatMatchingDocIds) {
                const docId = item?.id != null ? String(item.id).toLowerCase() : '';
                if (!docId || !makatMatchingDocIds.has(docId)) {
                    return false;
                }
            }

            if (selectedClientId != null && selectedClientId !== '') {
                if (String(item?.accountCodeId) !== String(selectedClientId)) {
                    return false;
                }
            }

            if (selectedStatuses.length > 0) {
                if (item?.isCanceled) {
                    return false;
                }
                const rowType = Number(item?.transactionDocumentType);
                if (STATUS_HIDDEN_ROW_TYPES.includes(rowType)) {
                    return false;
                }
                const description = String(item?.description || '');
                if (description.includes('ביטול')) {
                    return false;
                }
                const statusKey = getStatusKey(item);
                if (!selectedStatuses.includes(statusKey)) {
                    return false;
                }
            }

            return (
                item?.accountCodeName?.toLowerCase()?.includes(query) || // Safely access item.title
                amountString?.includes(query) ||
                formatDate(item?.documentDate)?.includes(query) ||
                item?.reference?.includes(query) ||
                item?.sortCodeId?.includes(query) ||
                item?.description?.includes(query) ||
                item?.uploadNumber?.toString()?.includes(query)
            );
        });
        if (sortConfig.key) {
            sortedData.sort((a, b) => {
                if (sortConfig.type === 'newest') {
                    const highlightedIds = type === 'Incomes' ? client.documentIds.incomes : client.documentIds.expenses;
                    const aIsHighlighted = highlightedIds.includes(a.id);
                    const bIsHighlighted = highlightedIds.includes(b.id);

                    if (sortConfig.direction === 'ascending') {
                        // Ascending: Non-highlighted (older) items first
                        if (!aIsHighlighted && bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is older, hence "lower")
                        } else if (aIsHighlighted && !bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is older, hence "lower")
                        }
                    } else {
                        // Descending: Highlighted (newer) items first
                        if (aIsHighlighted && !bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is newer, hence "higher")
                        } else if (!aIsHighlighted && bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is newer, hence "higher")
                        }
                    }
                } else {
                    const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
                    const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined
                    if (sortConfig.type === 'number') {
                        return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                    } else if (sortConfig.type === 'date') {
                        return sortConfig.direction === 'ascending' ? new Date(aValue) - new Date(bValue) : new Date(bValue) - new Date(aValue);
                    } else { // default to string comparison
                        return sortConfig.direction === 'ascending' ? aValue?.localeCompare(bValue) : bValue?.localeCompare(aValue);
                    }
                }
            });
        }

        return sortedData;
    }, [data, searchQuery, sortConfig, documentTypes, paymentMethods, type, client, selectedMakats, makatMatchingDocIds, selectedClientId, selectedStatuses]);

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // navigate('/client-details', { state: { client } });
            goBack()
        }
    };

    const handleAccountChange = (selectedOption, field) => {
        if (field === 'debitAccount' || field === 'creditAccount') {
            const name = accountCardEditDownloadOptions.find(option => option.cardId === selectedOption.value)?.name;
            if (selectedOption.value < 0) {

                setOriginalAccountCardId(editedItem.cardId)
            }
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, debitAccount: selectedOption.value, accountCaseId: selectedOption.accountCaseId }) : setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, creditAccount: selectedOption.value, accountCaseId: selectedOption.accountCaseId });
        } else if (field === 'accountCodeName') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedAddAccountCard(true);
                setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '', accountCaseId: '' })
            }
            else {
                const cardId = accountCardEditDownloadOptions.find(option => option.name === selectedOption.value)?.cardId;
                type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeName: selectedOption.value, accountCodeId: cardId, debitAccount: cardId, accountCaseId: selectedOption.accountCaseId }) : setEditedItem({ ...editedItem, accountCodeName: selectedOption.value, accountCodeId: cardId, creditAccount: cardId, accountCaseId: selectedOption.accountCaseId });
            }
        }
    };

    const closeDownloadModal = () => {
        setShowDownloadModal(false);
    };

    const handleRangeChange = async () => {
        const next = !isRange;
        isRangeRef.current = next;
        if (next) {
            await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
        } else {
            await fetchDocuments(new Date(sortDate));
        }
        setIsRange(next);
        localStorage.setItem('IsRange', next);
    }

    const handleDateBasisChange = async (byDocumentDate) => {
        if (byDocumentDate === filterByDocumentDate) return;
        filterByDocumentDateRef.current = byDocumentDate;
        setFilterByDocumentDate(byDocumentDate);
        localStorage.setItem('transactionDocsFilterByDocumentDate', String(byDocumentDate));
        if (isRangeRef.current) {
            await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
        } else {
            await fetchDocuments(new Date(sortDate));
        }
    };

    const handleDocumentDayChange = async (date) => {
        if (!date) return;
        documentDayRef.current = date;
        setDocumentDay(date);
        localStorage.setItem('TransactionDocumentDay', toUtcDayStart(date).toISOString());
        await fetchExactDocumentDates(date, date, { checkMonthClosed: true });
    };

    const handleDocumentDayStartChange = async (date) => {
        if (!date) return;
        let end = documentDayEndRef.current || date;
        if (end < date) end = date;
        documentDayStartRef.current = date;
        documentDayEndRef.current = end;
        setDocumentDayStart(date);
        setDocumentDayEnd(end);
        localStorage.setItem('TransactionDocumentDayStart', toUtcDayStart(date).toISOString());
        localStorage.setItem('TransactionDocumentDayEnd', toUtcDayStart(end).toISOString());
        await fetchExactDocumentDates(date, end, { checkMonthClosed: false });
    };

    const handleDocumentDayEndChange = async (date) => {
        if (!date) return;
        let start = documentDayStartRef.current || date;
        if (start > date) start = date;
        documentDayStartRef.current = start;
        documentDayEndRef.current = date;
        setDocumentDayStart(start);
        setDocumentDayEnd(date);
        localStorage.setItem('TransactionDocumentDayStart', toUtcDayStart(start).toISOString());
        localStorage.setItem('TransactionDocumentDayEnd', toUtcDayStart(date).toISOString());
        await fetchExactDocumentDates(start, date, { checkMonthClosed: false });
    };

    const paymentMethodOptions = useMemo(() => ([
        { value: 'Cash', label: t('PaymentMethod_Cash') },
        { value: 'BankTransfer', label: t('PaymentMethod_BankTransaction') },
        { value: 'Check', label: t('PaymentMethod_Check') },
        { value: 'CreditCard', label: t('PaymentMethod_CreditCard') },
        { value: 'Offset', label: t('offsets') },
    ]), [t]);

    const paymentMethodLabel = useCallback((method) => {
        const match = paymentMethodOptions.find((option) => option.value === method);
        return match?.label || method;
    }, [paymentMethodOptions]);

    const handleOpenInvoiceCreator = () => {
        setInvoiceModalChoiceVisible(true);
    };

    const handleOpenDocumentSettings = async () => {
        if (client?.caseId && token) {
            try {
                const updatedClient = await ClientService.GetClient(token, client.caseId);
                setClient(updatedClient);
            } catch (error) {
                console.error('Error refreshing client before document settings:', error);
            }
        }
        setDocumentSettingsModalOpen(true);
    };

    const shouldAutoOpenDocumentSettingsRef = useRef(false);
    const hasOpenedSettingsDialogRef = useRef(false);

    const clearDocumentSettingsDialogNavigationFlag = useCallback(() => {
        if (location.state?.openDocumentSettingsDialog !== true) {
            return;
        }
        const { openDocumentSettingsDialog: _omit, ...restState } = location.state;
        const nextState = Object.keys(restState).length > 0 ? restState : null;
        navigate(`${location.pathname}${location.search}${location.hash}`, {
            replace: true,
            state: nextState,
        });
    }, [location.pathname, location.search, location.hash, location.state, navigate]);

    const handleCloseDocumentSettings = () => {
        setDocumentSettingsModalOpen(false);
        clearDocumentSettingsDialogNavigationFlag();
    };

    // Consume the Settings-menu flag immediately so it does not survive refresh.
    useEffect(() => {
        if (location.state?.openDocumentSettingsDialog === true) {
            shouldAutoOpenDocumentSettingsRef.current = true;
            clearDocumentSettingsDialogNavigationFlag();
        }
    }, [location.state?.openDocumentSettingsDialog, clearDocumentSettingsDialogNavigationFlag]);

    useEffect(() => {
        if (
            !shouldAutoOpenDocumentSettingsRef.current ||
            hasOpenedSettingsDialogRef.current ||
            !isFirstUserFetched ||
            loading ||
            !client?.caseId ||
            !token
        ) {
            return;
        }
        hasOpenedSettingsDialogRef.current = true;
        const timer = setTimeout(() => {
            void handleOpenDocumentSettings();
        }, 500);
        return () => clearTimeout(timer);
    }, [isFirstUserFetched, loading, client?.caseId, token]);

    const handleDocumentSettingsSave = async () => {
        try {
            // Refresh client data from server to get updated signature/profile photo
            const updatedClient = await ClientService.GetClient(token, client.caseId);
            
            // Update local state
            setClient(updatedClient);
            
            // Update location state so it persists on navigation (never re-apply auto-open flag)
            const { openDocumentSettingsDialog: _omit, ...restState } = location.state || {};
            const updatedLocationState = {
                ...restState,
                client: updatedClient,
            };

            navigate(`${location.pathname}${location.search}${location.hash}`, {
                replace: true,
                state: updatedLocationState,
            });
            
            toast.success(t('DocumentSettingsSavedSuccessfully'));
        } catch (error) {
            console.error('Error refreshing client data:', error);
            toast.error(t('ErrorRefreshingClientData'));
        }
    };




    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '' })
        setEditedAddAccountCard(false);
    };

    const handleEditAddAccountChange = (selectedOption, field) => {

        if (field === 'AccountCodeId') {
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeId: selectedOption, debitAccount: selectedOption }) : setEditedItem({ ...editedItem, accountCodeId: selectedOption, creditAccount: selectedOption });
        }
        else if (field === 'AccountCodeName') {
            setEditedItem({ ...editedItem, accountCodeName: selectedOption })
        }
        else {
            setEditedItem({ ...editedItem, accountCaseId: selectedOption })

        }
    };

    const handlePriceIncludingVATChange = (event) => {
        setPriceIncludingVAT(event.target.value === 'true');
    };


    //table functions
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold'
    }

    const [openedIframeUrl, setOpenedIframeUrl] = useState('');
    const [bigIframeModalOpen, setBigIframeModalOpen] = useState(false);
    const openPdfInNewTab = (pdfUrl) => {
        if (pdfUrl) {
            setOpenedIframeUrl(pdfUrl ? pdfUrl : NoDocumentsPdf);
            setBigIframeModalOpen(true);
        }
    };

    const handleCloseIframeModal = () => {
        setBigIframeModalOpen(false);
        setOpenedIframeUrl('');
    };
    const fileInputRef = useRef();
    const buttonData = [
        {
            label: 'create',
            onClick: () => handleOpenInvoiceCreator(),
            icon: () => (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path d="M12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11V6C11 5.44772 11.4477 5 12 5Z" fill="white"/>
                </svg>
            ),
        },
        {
            label: 'References',
            onClick: () => handleOpenReferences(),
            icon: () => (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V12.9726L14.4306 11.0119C14.7001 10.6974 15.1736 10.661 15.4881 10.9306C15.8026 11.2001 15.839 11.6736 15.5694 11.9881L12.5694 15.4881C12.427 15.6543 12.2189 15.75 12 15.75C11.7811 15.75 11.573 15.6543 11.4306 15.4881L8.43056 11.9881C8.16099 11.6736 8.19741 11.2001 8.51191 10.9306C8.8264 10.661 9.29988 10.6974 9.56944 11.0119L11.25 12.9726V2C11.25 1.58579 11.5858 1.25 12 1.25ZM6.99583 8.25196C7.41003 8.24966 7.74768 8.58357 7.74999 8.99778C7.7523 9.41199 7.41838 9.74964 7.00418 9.75194C5.91068 9.75803 5.1356 9.78643 4.54735 9.89448C3.98054 9.99859 3.65246 10.1658 3.40901 10.4092C3.13225 10.686 2.9518 11.0746 2.85315 11.8083C2.75159 12.5637 2.75 13.5648 2.75 15.0002V16.0002C2.75 17.4356 2.75159 18.4367 2.85315 19.1921C2.9518 19.9259 3.13225 20.3144 3.40901 20.5912C3.68577 20.868 4.07435 21.0484 4.80812 21.1471C5.56347 21.2486 6.56458 21.2502 8 21.2502H16C17.4354 21.2502 18.4365 21.2486 19.1919 21.1471C19.9257 21.0484 20.3142 20.868 20.591 20.5912C20.8678 20.3144 21.0482 19.9259 21.1469 19.1921C21.2484 18.4367 21.25 17.4356 21.25 16.0002V15.0002C21.25 13.5648 21.2484 12.5637 21.1469 11.8083C21.0482 11.0746 20.8678 10.686 20.591 10.4092C20.3475 10.1658 20.0195 9.99859 19.4527 9.89448C18.8644 9.78643 18.0893 9.75803 16.9958 9.75194C16.5816 9.74964 16.2477 9.41199 16.25 8.99778C16.2523 8.58357 16.59 8.24966 17.0042 8.25196C18.0857 8.25799 18.9871 8.28387 19.7236 8.41916C20.4816 8.55839 21.1267 8.82364 21.6517 9.34857C22.2536 9.95048 22.5125 10.7084 22.6335 11.6085C22.75 12.4754 22.75 13.5778 22.75 14.9453V16.0551C22.75 17.4227 22.75 18.525 22.6335 19.392C22.5125 20.2921 22.2536 21.0499 21.6517 21.6519C21.0497 22.2538 20.2919 22.5127 19.3918 22.6337C18.5248 22.7503 17.4225 22.7502 16.0549 22.7502H7.94513C6.57754 22.7502 5.47522 22.7503 4.60825 22.6337C3.70814 22.5127 2.95027 22.2538 2.34835 21.6519C1.74643 21.0499 1.48754 20.2921 1.36652 19.392C1.24996 18.525 1.24998 17.4227 1.25 16.0551V14.9453C1.24998 13.5778 1.24996 12.4754 1.36652 11.6085C1.48754 10.7084 1.74643 9.95048 2.34835 9.34857C2.87328 8.82363 3.51835 8.55839 4.27635 8.41916C5.01291 8.28387 5.9143 8.25798 6.99583 8.25196Z" fill="white" />
                </svg>
            ),
        },
        {
            label: 'DocumentSettings',
            onClick: () => handleOpenDocumentSettings(),
            icon: () => (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="4" y="2" width="16" height="20" rx="2" fill="white" fillOpacity="0.15"/>
                    <rect x="6" y="4" width="12" height="16" rx="1" fill="white"/>
                    <rect x="8" y="7" width="8" height="2" rx="1" fill="#304FFF"/>
                    <rect x="8" y="11" width="8" height="2" rx="1" fill="#304FFF"/>
                    <rect x="8" y="15" width="5" height="2" rx="1" fill="#304FFF"/>
                </svg>
            ),
        },
        {
            label: 'TaxAuthorityProblemInvoices',
            onClick: () => setShowProblemInvoicesModal(true),
            icon: () => (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M6 3h7l4 4v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
                        fill="white"
                        fillOpacity="0.2"
                    />
                    <path
                        d="M6 3h7l4 4v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                    />
                    <path d="M13 3.5V7h3.5" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
                    <path d="M7.5 11h6M7.5 14h6M7.5 17h3.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M16.2 11.2L21 19.5H11.4L16.2 11.2z" fill="white" />
                    <path d="M16.2 14v2.2" stroke="#304FFF" strokeWidth="1.6" strokeLinecap="round" />
                    <circle cx="16.2" cy="18.05" r="0.9" fill="#304FFF" />
                </svg>
            ),
            style: { minWidth: '200px' },
        },
        {
            label: 'LinkDocuments',
            onClick: () => handleOpenLinkDocuments(),
            icon: () => (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M10.6 13.4a3.5 3.5 0 0 0 4.95 0l3.54-3.54a3.5 3.5 0 0 0-4.95-4.95l-1.06 1.06"
                        stroke="white"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                    />
                    <path
                        d="M13.4 10.6a3.5 3.5 0 0 0-4.95 0l-3.54 3.54a3.5 3.5 0 0 0 4.95 4.95l1.06-1.06"
                        stroke="white"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                    />
                </svg>
            ),
        },
    ];

    const handleDuplicateDocument = async (rowItem) => {
        try {
            setLocalLoading(true);
            
            
            // Fetch document items
            const docItemsArray = await DocumentService.GetDocumentItems(client.caseId, rowItem.id, token);
            
            
            // Fetch complete client items to get makat and name
            const clientItemsResponse = await ClientItemsService.GetClientItemsByCaseId(client.caseId, token);
            let enrichedItems = docItemsArray || [];
            
            if (clientItemsResponse.ok) {
                const clientItemsData = await clientItemsResponse.json();
                
                // Enrich document items with makat and name from client items
                enrichedItems = (docItemsArray || []).map(docItem => {
                    const matchingClientItem = clientItemsData.find(ci => ci.id === docItem.itemId);
                    if (matchingClientItem) {
                        return {
                            ...docItem,
                            makat: matchingClientItem.makat,
                            name: matchingClientItem.name,
                        };
                    }
                    return docItem;
                });
                
            }
            
            // Map transactionDocumentType to navigation type
            const typeMapping = {
                1: { navigateTo: '/CreateInvoice', type: 'Quotation' },        // Quotation
                2: { navigateTo: '/CreateInvoice', type: 'Order' },            // Order
                3: { navigateTo: '/CreateInvoice', type: 'Transaction' },      // Transaction
                4: { navigateTo: '/CreateInvoice', type: 'TaxInvoice' },       // Tax Invoice
                5: { navigateTo: '/CreateInvoice', type: 'CreditNote' },       // Credit Note
                6: { navigateTo: '/ReceiptTax', type: 'ReceiptTax' },          // Invoice Receipt
                7: { navigateTo: '/ReceiptTax', type: 'Receipt' },             // Receipt
            };
            
            const mapping = typeMapping[rowItem.transactionDocumentType];
            
            if (!mapping) {
                toast.error(t('UnsupportedDocumentType'));
                setLocalLoading(false);
                return;
            }
            
            // Determine priceIncludingVAT from rowItem or calculate from items vs total
            let priceIncludingVAT = rowItem.priceIncludingVAT !== undefined 
                ? rowItem.priceIncludingVAT 
                : (rowItem.PriceIncludingVAT !== undefined ? rowItem.PriceIncludingVAT : undefined);
            
            // If priceIncludingVAT is not in rowItem, calculate it from items sum vs total amount
            if (priceIncludingVAT === undefined && enrichedItems && enrichedItems.length > 0 && rowItem.amount) {
                // Calculate sum of all items (price * quantity - discount)
                const itemsSum = enrichedItems.reduce((sum, item) => {
                    const price = parseFloat(item.price) || 0;
                    const quantity = parseFloat(item.quantity) || 1;
                    const discount = parseFloat(item.discount) || 0;
                    const baseAmount = price * quantity;
                    const discountedAmount = baseAmount - (baseAmount * discount / 100);
                    return sum + discountedAmount;
                }, 0);
                
                const totalAmount = parseFloat(rowItem.amount) || 0;
                // Credit documents store a negative amount while their line prices stay
                // positive, so only magnitudes may be compared here.
                const difference = Math.abs(Math.abs(itemsSum) - Math.abs(totalAmount));
                
                // If sum of items equals total amount (within small tolerance), it's PriceIncludingVAT (true)
                // Otherwise, it's PriceExcludingVAT (false)
                if (difference < 0.01) {
                    priceIncludingVAT = true; // PriceIncludingVAT
                } else {
                    priceIncludingVAT = false; // PriceExcludingVAT
                }
            } else if (priceIncludingVAT === undefined) {
                // Default to false (PriceExcludingVAT) if we can't determine it
                priceIncludingVAT = false;
            }
            
            
            // Fetch client data to get location
            let clientLocation = null;
            try {
                const clientData = await ClientService.GetClient(token, client.caseId);
                clientLocation = clientData?.location || null;
            } catch (err) {
                console.warn('Could not fetch client location:', err);
            }
            
            // Prepare document data for duplication
            const duplicateData = {
                ...rowItem,
                items: enrichedItems,
                priceIncludingVAT: priceIncludingVAT, // Use calculated or existing value
                location: clientLocation || rowItem.location, // Use client location if available, otherwise use rowItem location
                // Clear fields that should not be duplicated
                id: undefined,
                reference: '',
                documentUrl: '',
                createdDate: undefined,
                modifiedDate: undefined,
            };
            
            
            // Navigate to appropriate creation page
            viewDocumentCreate(mapping.navigateTo, mapping.type, duplicateData);
            
        } catch (err) {
            console.error('Error duplicating document:', err);
            toast.error(t('ErrorDuplicatingDocument'));
        } finally {
            setLocalLoading(false);
        }
    };

    const handleActionTriggered = async (actionValue, rowItem) => {
        try {
            // Handle duplicate document action
            if (actionValue.value === 'duplicate_document') {
                handleDuplicateDocument(rowItem);
                return;
            }

            if (rowItem?.isCanceled) {
                toast.error(t('CanceledDocumentCannotCreateOrLink'));
                return;
            }

            if (actionValue.value === GROUP_RECEIPT_GENERATE) {
                const groupInvoices = getGroupedOpenInvoices(rowItem, data);
                if (groupInvoices.length < 2) {
                    toast.error(t('SelectMultipleInvoices'));
                    return;
                }
                await handleMultiDocumentGenerate(groupInvoices);
                return;
            }

            setSourceDocs([]);
            setConversionChildren(getConversionDescendants(rowItem, data));
            setLocalLoading(true);

            // 1) Load the doc items from server
            const docItemsArray = await DocumentService.GetDocumentItems(client.caseId, rowItem.id, token);
            setPendingAction(actionValue);

            // 2) Determine whether to skip showing Add Items modal
            const shouldSkipAddItemsModal =
                (actionValue.value === 'generate_receipt' || actionValue.value === 'cancel_receipt');

            if ((!docItemsArray || docItemsArray.length === 0) && !shouldSkipAddItemsModal) {
                // Show Add Items modal ONLY if it's not a skip case
                setShowAddItemsModal(true);
                setCurrentDoc(rowItem);
            } else {
                // Otherwise proceed to generate modal
                setCurrentDoc(rowItem);
                setDocItems(docItemsArray);
                setShowGenerateModal(true);
            }
        } catch (err) {
            console.error('Error retrieving document items:', err);
            toast.error(t('ErrorRetrievingDocumentItems'));
        } finally {
            setLocalLoading(false);
        }
    };


    const handleMultiDocumentGenerate = async (rows) => {
        try {
            setLocalLoading(true);

            if (rows.some((row) => row?.isCanceled)) {
                toast.error(t('CanceledDocumentCannotCreateOrLink'));
                return;
            }

            const config = getMultiDocumentGenerateConfig(rows);
            if (!config) {
                toast.error(t('SelectMultipleSameDocuments') || 'Select multiple documents of the same type');
                return;
            }

            if (config.requiresTaxableClient && isTaxExempt) {
                toast.error(t('ActionNotAllowedForTaxExempt') || t(config.selectErrorKey));
                return;
            }

            if (!haveSameCustomerAccount(rows)) {
                toast.error(t(config.differentCustomersKey));
                return;
            }

            const itemsArrays = await Promise.all(
                rows.map((row) => DocumentService.GetDocumentItems(client.caseId, row.id, token))
            );

            // Receipts from invoices can proceed without line items (same as single-doc flow).
            // Invoice generation requires items on every source document.
            const requiresItems = config.actionValue === 'generate_invoice';
            if (requiresItems) {
                const emptyDocs = rows.filter((row, index) => !itemsArrays[index]?.length);
                if (emptyDocs.length > 0) {
                    const refs = emptyDocs.map((d) => d.reference).join(', ');
                    toast.error(t(config.missingItemsKey, { refs }) || `Documents missing items: ${refs}`);
                    return;
                }
            }

            const { mergedItems, totalAmount } = mergeMultiSourceDocumentItems(rows, itemsArrays);

            setPendingAction({ label: config.actionLabel, value: config.actionValue });
            setCurrentDoc({
                ...rows[0],
                amount: totalAmount,
                sourceDocuments: rows,
            });
            setSourceDocs(rows);
            setConversionChildren([]);
            setDocItems(mergedItems);
            setShowGenerateModal(true);
        } catch (err) {
            console.error('Error merging documents for generation:', err);
            toast.error(t('ErrorRetrievingDocumentItems'));
        } finally {
            setLocalLoading(false);
        }
    };

    const getRowsBySelectionIds = useCallback((ids = selectionModel) => (
        filteredAndSortedData.filter((r) =>
            ids.some((id) => String(id) === String(r.id))
        )
    ), [filteredAndSortedData, selectionModel]);

    const handleSetDocumentStatus = async (row, nextStatus) => {
        if (!row?.id || !client?.caseId || !token) return;
        const nextClosed = nextStatus === LIFECYCLE_STATUS.CLOSED;
        try {
            setLocalLoading(true);
            const resp = await DocumentService.SetDocumentStatus(row.id, client.caseId, nextStatus, token);
            if (!resp.ok) {
                const text = await resp.text();
                throw new Error(text || 'Failed to update document status');
            }
            toast.success(nextClosed ? t('DocumentMarkedClosed') : t('DocumentMarkedOpen'));
            if (isRange) {
                await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
            } else {
                await fetchDocuments(new Date(sortDate));
            }
        } catch (err) {
            console.error('Error toggling document status:', err);
            toast.error(t('DocumentStatusUpdateFailed'));
        } finally {
            setLocalLoading(false);
        }
    };

    const handleResetDocumentStatus = async (row) => {
        if (!row?.id || !client?.caseId || !token) return;
        try {
            setLocalLoading(true);
            const resp = await DocumentService.ResetDocumentStatus(row.id, client.caseId, token);
            if (!resp.ok) {
                const text = await resp.text();
                throw new Error(text || 'Failed to reset document status');
            }
            toast.success(t('DocumentStatusRestoredAutomatic'));
            if (isRange) {
                await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
            } else {
                await fetchDocuments(new Date(sortDate));
            }
        } catch (err) {
            console.error('Error resetting document status:', err);
            toast.error(t('DocumentStatusUpdateFailed'));
        } finally {
            setLocalLoading(false);
        }
    };

    const handleOpenLinkDocuments = () => {
        if (!client?.caseId || !token) return;
        if (selectionModel.length === 0) {
            toast.info(t('LinkDocumentsSelectRows'));
            return;
        }
        const selectedRows = selectionModel.map((id) =>
            (data || []).find((row) => String(row.id) === String(id)) || { id });
        if (selectedRows.some((row) => row?.isCanceled)) {
            toast.error(t('CanceledDocumentCannotCreateOrLink'));
            return;
        }
        const documentId = pickLinkPrimary(selectedRows) ?? selectionModel[0];
        const invoiceGroup = selectedRows.length > 1
            && selectedRows.every((row) => Number(row?.transactionDocumentType) === TAX_INVOICE_TYPE)
            && haveSameCustomerAccount(selectedRows);
        setLinkDocumentsTarget({
            documentId,
            pairDocumentIds: selectionModel.filter((id) => String(id) !== String(documentId)),
            invoiceGroupIds: invoiceGroup ? selectedRows.map((row) => row.id) : null,
        });
    };

    const handleDocumentsLinked = async () => {
        if (isRange) {
            await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
        } else {
            await fetchDocuments(new Date(sortDate));
        }
    };

    const resolveContextMenuItems = useCallback((clickedRow) => {
        if (!clickedRow) return [];

        const selectedRows = getRowsBySelectionIds();
        const clickedInSelection = selectedRows.some(
            (r) => String(r.id) === String(clickedRow.id)
        );
        const useBulkMenu = selectionModel.length > 1 && clickedInSelection;

        if (useBulkMenu) {
            const items = [
                { label: t('Print'), onClick: () => handleBulkAction('bulk_print', selectionModel) },
                { label: t('SendByEmail'), onClick: () => handleBulkAction('bulk_email', selectionModel) },
                { label: t('SendByWhatsApp'), onClick: () => handleBulkAction('bulk_whatsapp', selectionModel) },
                { label: t('Download'), onClick: () => handleBulkAction('bulk_download', selectionModel) },
            ];

            const multiConfig = getMultiDocumentGenerateConfig(selectedRows);
            if (multiConfig && canShowMultiDocumentGenerate(selectedRows, isTaxExempt)) {
                items.push({
                    label: t(multiConfig.actionLabel),
                    onClick: () => handleMultiDocumentGenerate(selectedRows),
                });
            }

            return items;
        }

        const items = [
            {
                label: `${t('DownloadPDFFile')} (מקור)`,
                onClick: () => handleDownloadDocument(clickedRow, 'original'),
            },
            {
                label: `${t('DownloadPDFFile')} (העתק)`,
                onClick: () => handleDownloadDocument(clickedRow, 'copy'),
            },
            { type: 'separator' },
            ...(!clickedRow.isCanceled && !STATUS_HIDDEN_ROW_TYPES.includes(Number(clickedRow.transactionDocumentType))
                ? [
                    ...(getProcessingStatus(clickedRow) !== LIFECYCLE_STATUS.OPEN
                        ? [{
                            label: t('MarkAsOpen'),
                            onClick: () => handleSetDocumentStatus(clickedRow, LIFECYCLE_STATUS.OPEN),
                        }]
                        : []),
                    ...(getProcessingStatus(clickedRow) !== LIFECYCLE_STATUS.CLOSED
                        ? [{
                            label: t('MarkAsClosed'),
                            onClick: () => handleSetDocumentStatus(clickedRow, LIFECYCLE_STATUS.CLOSED),
                        }]
                        : []),
                    ...(clickedRow.manualStatus != null
                        ? [{
                            label: t('RestoreAutomaticStatus'),
                            onClick: () => handleResetDocumentStatus(clickedRow),
                        }]
                        : []),
                ]
                : []),
            ...getRowActions(clickedRow).map((item) => ({
                label: t(item.label),
                onClick: () => handleActionTriggered(item, clickedRow),
            })),
        ];

        return items;
    }, [
        getRowsBySelectionIds,
        selectionModel,
        t,
        isTaxExempt,
        handleBulkAction,
        handleMultiDocumentGenerate,
        handleDownloadDocument,
        getRowActions,
        handleActionTriggered,
        handleSetDocumentStatus,
        handleResetDocumentStatus,
    ]);


    // 2) Once user closes the "Add Items" modal and saves, we create those items in DB
    //    then optionally call generate/cancel, etc.:
    const handleItemsSaved = async (newItems, pendingAction, doc) => {
        try {


            const response = await DocumentService.AddDocumentItems(client.caseId, currentDoc.id, newItems, token);

            const result = await response.json();

            if (!result.success) {
                toast.error(result.message || 'Failed to save document items.');
                return;
            }

            const ClientItemsResponse = await ClientItemsService.GetClientItemsByCaseId(client.caseId, token);
            if (ClientItemsResponse.ok) {
                const ClientItemsData = await ClientItemsResponse.json();
                ClientItemsData.unshift({ makat: 'add-item', name: t('NewItem') });
                setClientItems(ClientItemsData);
            }

            // Use the returned docItems from backend
            setDocItems(result.data);
            setPendingAction(pendingAction);
            setCurrentDoc(doc);
            setShowAddItemsModal(false);
            setShowGenerateModal(true);
        } catch (err) {
            console.error('Error saving new items:', err);
            toast.error('ErrorSavingNewItems');
        }
    };


    // -----------------------------------------------------
    // 5) PDF Generation: Draft & Final
    // -----------------------------------------------------
    /** 
     * For when the user clicks "draft" from a doc or "generate" for an item. 
     * Example usage: 
     * 1) Possibly do "minus amount" if docType in [1,2,3], etc. 
     * 2) Call DocumentService to get a PDF blob. 
     * 3) Store in draftPdfBlob + open the draft modal.
    **/
    //////////////////////////////////////////////
    // handleDraftGenerateNewDoc
    //////////////////////////////////////////////
    const handleDraftGenerateNewDoc = async (mergedData) => {
        try {

            setPendingDocData(mergedData);
            // Identify the action => doc type index + negative
            const actionValue = mergedData?.pendingAction?.value;
            if (!actionValue || !ACTION_TO_TYPE_INDEX[actionValue]) {
                toast.error("Invalid or missing pending action for draft generation.");
                return;
            }

            const canProceed = await ensureNoPendingDecisionTxDocs(mergedData, 'draft');
            if (!canProceed) {
                return;
            }

            const { index, negative } = ACTION_TO_TYPE_INDEX[actionValue];
            const modalTypeInfo = InvoiceModalTypes[index];


            // For doc type = 5 or 6 => we need receipt items
            const isReceiptItemsEmpty = !mergedData.receiptItems ||
                Object.values(mergedData.receiptItems).every(arr => !arr || arr.length === 0);
            if ((index === 5 || index === 6 || index === 7 || index === 8) && isReceiptItemsEmpty) {
                setShowReceiptItemsModal(true);
                return;
            }

            // Flip item prices if negative
            const itemsArray = mergedData.items || [];

            const finalItems = itemsArray.map((item) => {
                let priceVal = parseFloat(item.price || 0);
                if (negative) priceVal *= -1;
                return { ...item, price: priceVal };
            });

            // Month closure check (same doc families as tax-authority rules)
            if (MODAL_INDICES_TAX_AUTHORITY.includes(index)) {
                const resp = await ClientService.CheckIfMonthClosed(
                    mergedData.documentInfo.caseId,
                    new Date(mergedData.documentInfo.documentDate),
                    token
                );
                if (resp.ok) {
                    const isClosed = await resp.json();
                    if (isClosed) {
                        toast.info(t('MonthReportAlreadyClosedTryAgain'));
                        return;
                    }
                }
            }

            // Build draft payload
            let Receipt = {};
            const isDeferredReceipt = actionValue === 'generate_receipt_deferred'
            if (index === 5 || index === 6 || index === 7 || index === 8) {
                const withholdingTaxValue = parseFloat(mergedData.invoiceWithholdingTax) || 0;
                Receipt = {
                    WithholdingTax: withholdingTaxValue,
                    IsInvoiceReceipt: index === 5 || index === 7,
                    Title: InvoiceModalTypes[index]?.TransactionDocumentTitle,
                    DeferredReceipt: isDeferredReceipt || false,
                    ...buildRelatedInvoiceLinkForReceipt(actionValue, mergedData.documentInfo),
                };
            }


            // Generate base description and concatenate with user-entered description
            const baseDescription = generateDescription(actionValue, mergedData.documentInfo, t);
            const userDescription = mergedData.description || '';
            const fullDescription = userDescription 
                ? `${baseDescription} - ${userDescription}` 
                : baseDescription;

            const draftPayload = {
                CaseId: client?.caseId,
                AccountantId: client?.accountantId,
                Name: client?.name,
                Description: fullDescription,
                Reference: '',
                ClientName: mergedData.accountCardInfo?.name || '',
                ClientCaseId: mergedData.accountCardInfo?.accountCaseId || '',
                PhoneNumber: client?.phoneNumber || '',
                Email: client?.email || '',
                Website: client?.website || '',
                Location: client?.location || '',
                ClientLocation: mergedData.accountCardInfo?.location || '',
                ClientEmail: mergedData.accountCardInfo?.email || '',
                ClientPhoneNumber: mergedData.accountCardInfo?.phoneNumber || '',
                Date: new Date(mergedData.documentInfo.documentDate)?.toISOString(),
                reportingMonthDate: new Date(mergedData.documentInfo.documentDate)?.toISOString(),
                Signature: '',
                AccountCodeId: mergedData.documentInfo.accountCodeId?.toString(),
                PriceIncludingVAT: mergedData.priceIncludingVat || false,
                ForceNoTax: mergedData.forceNoTax || false,
                DeferredReceipt: mergedData.deferredReceipt || false,
                Items: finalItems,
                ...Receipt,
                ...(index === 5 || index === 6 || index === 7 || index === 8
                    ? {
                        checks: mergedData.receiptItems?.checks || [],
                        creditCards: mergedData.receiptItems?.creditCards || [],
                        cash: mergedData.receiptItems?.cash || [],
                        bankTransactions: mergedData.receiptItems?.bankTransactions || [],
                        offsets: mergedData.receiptItems?.offsets || [],
                    }
                    : {})
            };

            // VAT Adjustment for Cancel Documents (Draft)
            // When canceling a document that originally had VAT == 0, we need to ensure
            // the cancel document also has VAT == 0 to maintain consistency.
            // This is achieved by:
            // 1. Checking if the original document had VAT == 0
            // 2. If so, setting ForceNoTax = true for the cancel document
            // 3. Updating all items to have vat = 0 and includeVat = false
            // Check if this is a cancel action and adjust VAT handling accordingly
            if (isDocumentCanceledByAction(actionValue, mergedData.documentInfo?.transactionDocumentType)) {
                // Check if the original document had VAT == 0
                const originalDocumentHadZeroVat = mergedData.documentInfo?.vat === 0;
                

                
                if (originalDocumentHadZeroVat) {
                    // Set ForceNoTax to true for the cancel document to maintain VAT == 0
                    draftPayload.ForceNoTax = true;
                    
                    // Also update the items to ensure they have no VAT
                    draftPayload.Items = finalItems.map(item => ({
                        ...item,
                        vat: 0,
                        includeVat: false
                    }));
                    
                } else {
                    // Original document had VAT, maintain the same VAT structure for cancel document
                    console.log('Draft - Cancel document maintaining original VAT structure');
                }
            }

            // Actually call your draft endpoint


            const result = await DocumentService.CreateDraftInvoice(
                modalTypeInfo.controller,
                modalTypeInfo.draftEndPoint,
                draftPayload,
                modalTypeInfo.type,                      // e.g. 'transaction', 'order'
                modalTypeInfo.TransactionDocumentTitle,  // e.g. 'הצעת מחיר', 'הזמנה'
                modalTypeInfo.TransactionDocumentType,   // e.g. 'Quotation', 'Order'
                token
            );

            if (Array.isArray(result)) {
                setDraftPdfBlobs(result);          // many PDFs (cancel flow)
            } else {
                setDraftPdfBlobs([result]);        // single PDF
            }
            setDraftPdfModalVisible(true);
            toast.success(t('DraftDocumentCreated'));
        } catch (err) {
            console.error("Error generating draft doc:", err);
            toast.error(t('DocumentGenerationFailed'));
        }
    };

    /**
     * When user finalizes the doc from the draft modal
     * or calls directly to finalize the doc.
     */
    //////////////////////////////////////////////
    // handleGenerateNewDoc
    //////////////////////////////////////////////

    const isDocumentCanceledByAction = (actionValue, documentType) => {
        const isCancelAction = actionValue?.startsWith('cancel_');

        // Special logic: generating a credit invoice cancels an invoice (type 4)
        const isCancelByCreditInvoice =
            actionValue === 'generate_credit_invoice' && documentType === 4;

        return isCancelAction || isCancelByCreditInvoice;
    };

    const generateDescription = (actionValue, documentInfo, t) => {
        if (documentInfo?.sourceDocuments?.length > 1) {
            const refs = documentInfo.sourceDocuments.map((d) => d.reference).join(', ');
            const sourceType = Number(documentInfo.sourceDocuments[0]?.transactionDocumentType);
            const sourceTypeName = Constants.TransactionDocuments?.[sourceType] || t('Document');
            return `הופק מ${sourceTypeName} מספר ${refs}`;
        }

        const { transactionDocumentType, reference } = documentInfo || {};
        const docTypeName = Constants.TransactionDocuments?.[transactionDocumentType] || t("Document");

        if (isDocumentCanceledByAction(actionValue, transactionDocumentType)) {
            return `ביטול ${docTypeName} מספר ${reference}`;
        }

        return `הופק מ${docTypeName} מספר ${reference}`;
    };

    /**
     * When the user generates a Receipt (or deferred Receipt) FROM a TaxInvoice,
     * automatically link the new PaymentAcceptance to the source invoice so it
     * appears as paid on the Accounts Receivable page for cards with PaymentTerms.
     *
     * Notes:
     * - For transactionDocumentType === 4 (TaxInvoice), `documentInfo.id` IS the
     *   Income id (see getDocumentTypeFromTransactionType), so we use it as the FK.
     * - We also pass the textual reference as a fallback for the resolver.
     * - For multiple source invoices, RelatedIncomeId uses the first invoice id,
     *   and RelatedInvoiceReference lists all references.
     * - Only applies to plain "generate_receipt"/"generate_receipt_deferred";
     *   "generate_invoice_receipt" already creates the income+receipt together
     *   via IsInvoiceReceipt and does not need a link.
     */
    const buildRelatedInvoiceLinkForReceipt = (actionValue, documentInfo) => {
        const isReceiptGeneration =
            actionValue === 'generate_receipt' || actionValue === 'generate_receipt_deferred';
        if (!isReceiptGeneration) return {};

        const sourceDocs = documentInfo?.sourceDocuments?.length > 1
            ? documentInfo.sourceDocuments
            : null;

        if (sourceDocs) {
            const allInvoices = sourceDocs.every(
                (d) => Number(d?.transactionDocumentType) === TAX_INVOICE_TYPE
            );
            if (!allInvoices || !sourceDocs[0]?.id) return {};
            return {
                RelatedIncomeId: sourceDocs[0].id,
                RelatedInvoiceReference: sourceDocs.map((d) => d.reference).filter(Boolean).join(', ') || null,
            };
        }

        const sourceIsInvoice = documentInfo?.transactionDocumentType === TAX_INVOICE_TYPE;
        if (!sourceIsInvoice || !documentInfo?.id) return {};
        return {
            RelatedIncomeId: documentInfo.id,
            RelatedInvoiceReference: documentInfo.reference || null,
        };
    };

    /**
     * The generation endpoints normally answer with the PDF. When the document was already issued
     * (its row and confirmation number exist) but a later bookkeeping step failed — a catalog item
     * deleted since the source document was created, for instance — they answer 200 with JSON
     * describing the issued document instead. Both are a success: the document must be shown, never
     * reported as an error, or the user would generate it again on a reference that is already spent.
     */
    const presentGeneratedDocument = async (result) => {
        const generated = Array.isArray(result) ? result : [result];
        const issuedPayload = generated.length === 1 && generated[0]?.type?.includes('application/json')
            ? generated[0]
            : null;

        if (!issuedPayload) {
            setFinalPdfBlobs(generated);
            setPdfModalVisible(true);
            return;
        }

        try {
            const data = JSON.parse(await issuedPayload.text());
            if (data?.presignedUrl) {
                setFinalPdfBlobs([data.presignedUrl]);
                setPdfModalVisible(true);
            }
        } catch (err) {
            console.error('Failed to read the issued document payload', err);
        }
    };

    const handleGenerateNewDoc = async (mergedData, isAuthCompleted = false, taxAuthorityOptions = null) => {
        try {
            setLocalLoading(true);

            const actionValue = mergedData?.pendingAction?.value;
            if (!actionValue || !ACTION_TO_TYPE_INDEX[actionValue]) {
                toast.error("Invalid or missing pending action for final generation.");
                setLocalLoading(false);
                return;
            }

            // Pre-check pending Tax Authority decision (unless already retrying with Decision)
            if (!taxAuthorityOptions?.decisionFlag && taxAuthorityOptions?.decisionFlag !== 0) {
                const canProceed = await ensureNoPendingDecisionTxDocs(mergedData, 'create');
                if (!canProceed) {
                    setLocalLoading(false);
                    return;
                }
            }

            const { index, negative } = ACTION_TO_TYPE_INDEX[actionValue];
            const modalTypeInfo = InvoiceModalTypes[index];

            // For doc type = 5 or 6 => need receipt items
            const isReceiptItemsEmpty = !mergedData.receiptItems ||
                Object.values(mergedData.receiptItems).every(arr => !arr || arr.length === 0);
            if ((index === 5 || index === 6 || index === 7 || index === 8) && isReceiptItemsEmpty) {
                setShowReceiptItemsModal(true);
                setLocalLoading(false);
                return;
            }

            // Flip item prices if negative
            const itemsArray = mergedData.items || [];
            const finalItems = itemsArray.map((item) => {
                let priceVal = parseFloat(item.price || 0);
                if (negative) priceVal *= -1;
                return { ...item, price: priceVal };
            });

            // Month closure check (same doc families as tax-authority rules)
            if (MODAL_INDICES_TAX_AUTHORITY.includes(index)) {
                const resp = await ClientService.CheckIfMonthClosed(
                    mergedData.documentInfo.caseId,
                    new Date(mergedData.documentInfo.documentDate),
                    token
                );
                if (resp.ok) {
                    const isClosed = await resp.json();
                    if (isClosed) {
                        toast.info(t('MonthReportAlreadyClosedTryAgain'));
                        setLocalLoading(false);
                        return;
                    }
                }
            }

            // Tax authority OAuth when amount above threshold (invoice receipt cancel uses index 7, not 5)
            // (same idea as CreateInvoice: skip OAuth when tax-exempt / no-VAT doc or user chose "no confirmation number")
            if (!isAuthCompleted && MODAL_INDICES_TAX_AUTHORITY.includes(index)) {
                const isTaxExemptOrNoTax =
                    Constants.TaxExemptTypes.includes(client?.caseType) || mergedData.forceNoTax;
                const isNeedToAskAboutConfirmationNumber =
                    !isTaxExemptOrNoTax && !mergedData.noNeedforConfirmationNumber;
                const amountWithoutVat = finalItems.reduce((sum, it) => sum + Math.abs(parseFloat(it.price || 0)), 0);
                const threshold = getIsraelInvoiceAmountLimit(mergedData.documentInfo.documentDate || new Date());
                if (amountWithoutVat >= threshold && isNeedToAskAboutConfirmationNumber) {
                    try {
                        const tokenData = await TaxAuthorityService.requestTokenClient(mergedData.documentInfo.caseId, token, Constants.TaxAuthorityScopes.CreationNumber);
                        if (tokenData?.authUrl) {
                            handleTaxAuthorityAuth(tokenData.authUrl, mergedData);
                            setLocalLoading(false);
                            return;
                        }
                    } catch (error) {
                        console.error("Error fetching token:", error);
                        toast.error(t('TaxAuthorityAuthFetchError'));
                        setLocalLoading(false);
                        return;
                    }
                }
            }

            // Construct receipt data
            let Receipt = {};
            const isDeferredReceipt = actionValue === 'generate_receipt_deferred'
            if (index === 5 || index === 6 || index === 7 || index === 8) {
                const withholdingTaxValue = parseFloat(mergedData.invoiceWithholdingTax) || 0;
                Receipt = {
                    WithholdingTax: withholdingTaxValue,
                    IsInvoiceReceipt: index === 5 || index === 7,
                    Title: InvoiceModalTypes[index]?.TransactionDocumentTitle,
                    DeferredReceipt: isDeferredReceipt || false,
                    ...buildRelatedInvoiceLinkForReceipt(actionValue, mergedData.documentInfo),
                };
            }

            // Generate base description and concatenate with user-entered description
            const baseFinalDescription = generateDescription(actionValue, mergedData.documentInfo, t);
            const userFinalDescription = mergedData.description || '';
            const fullFinalDescription = userFinalDescription 
                ? `${baseFinalDescription} - ${userFinalDescription}` 
                : baseFinalDescription;

            // Build final payload
            const finalPayload = {
                CaseId: client?.caseId,
                AccountantId: client?.accountantId,
                Name: client?.name,
                Description: fullFinalDescription,
                Reference: '',
                ClientName: mergedData.accountCardInfo?.name || '',
                ClientCaseId: mergedData.accountCardInfo?.accountCaseId || '',
                PhoneNumber: client?.phoneNumber || '',
                Email: client?.email || '',
                Website: client?.website || '',
                Location: client?.location || '',
                ClientLocation: mergedData.accountCardInfo?.location || '',
                ClientEmail: mergedData.accountCardInfo?.email || '',
                ClientPhoneNumber: mergedData.accountCardInfo?.phoneNumber || '',
                Date: new Date(mergedData.documentInfo.documentDate).toISOString(),
                reportingMonthDate: new Date(mergedData.documentInfo.documentDate).toISOString(),
                Signature: '',
                AccountCodeId: mergedData?.documentInfo?.accountCodeId?.toString(),
                PriceIncludingVAT: mergedData.priceIncludingVat,
                ForceNoTax: mergedData.forceNoTax || false,
                DeferredReceipt: mergedData.deferredReceipt || false,
                Items: finalItems,
                ...Receipt,
                ...(index === 5 || index === 6 || index === 7 || index === 8
                    ? {
                        checks: mergedData.receiptItems?.checks || [],
                        creditCards: mergedData.receiptItems?.creditCards || [],
                        cash: mergedData.receiptItems?.cash || [],
                        bankTransactions: mergedData.receiptItems?.bankTransactions || [],
                        offsets: mergedData.receiptItems?.offsets || [],
                    }
                    : {}),
                ...(isDocumentCanceledByAction(actionValue, mergedData.documentInfo?.transactionDocumentType)
                    ? { CanceledFrom: mergedData.documentInfo.id }
                    : {}),
                ...(() => {
                    const sourceIds = collectSourceDocumentIds(mergedData.documentInfo);
                    return sourceIds.length ? { SourceDocumentIds: sourceIds } : {};
                })(),
                ...(mergedData.sourceAllocations?.length
                    ? { SourceAllocations: mergedData.sourceAllocations }
                    : {}),
                ...(taxAuthorityOptions != null
                    ? {
                        Decision: taxAuthorityOptions.decisionFlag,
                        noNeedforConfirmationNumber: taxAuthorityOptions.forceNoConfirmationNumber === true,
                    }
                    : mergedData.noNeedforConfirmationNumber
                    ? { noNeedforConfirmationNumber: true }
                    : {})
            };

            // VAT Adjustment for Cancel Documents
            // When canceling a document that originally had VAT == 0, we need to ensure
            // the cancel document also has VAT == 0 to maintain consistency.
            // This is achieved by:
            // 1. Checking if the original document had VAT == 0
            // 2. If so, setting ForceNoTax = true for the cancel document
            // 3. Updating all items to have vat = 0 and includeVat = false
            // Check if this is a cancel action and adjust VAT handling accordingly
            if (isDocumentCanceledByAction(actionValue, mergedData.documentInfo?.transactionDocumentType)) {
                // Check if the original document had VAT == 0
                const originalDocumentHadZeroVat = mergedData.documentInfo?.vat === 0;
                
            
                
                if (originalDocumentHadZeroVat) {
                    // Set ForceNoTax to true for the cancel document to maintain VAT == 0
                    finalPayload.ForceNoTax = true;
                    
                    // Also update the items to ensure they have no VAT
                    finalPayload.Items = finalItems.map(item => ({
                        ...item,
                        vat: 0,
                        includeVat: false
                    }));
                    
                } else {
                    // Original document had VAT, maintain the same VAT structure for cancel document
                    console.log('Cancel document maintaining original VAT structure');
                }
            }

            // Call the final creation endpoint
            const result = await DocumentService.CreateNewInvoice(
                modalTypeInfo.controller,
                modalTypeInfo.endPoint,
                finalPayload,
                modalTypeInfo.type,
                modalTypeInfo.TransactionDocumentTitle,
                modalTypeInfo.TransactionDocumentType,
                token
            );

            await presentGeneratedDocument(result);
            toast.success(t('DocumentGeneratedSuccessfully'));
            await refreshPendingDecisionStatus(documentTypeFromModalIndex(index));
            if (isDocumentCanceledByAction(actionValue, mergedData.documentInfo?.transactionDocumentType)) {
                try {
                    const cancelResp = await DocumentService.CancelDocument(
                        mergedData.documentInfo?.id,
                        client?.caseId,
                        token,
                        mergedData.alsoCancelSourceDocuments
                    );

                    const cancelResult = await cancelResp.json();
                    if (cancelResp.ok && cancelResult.success) {
                        toast.success(t("DocumentCanceledSuccessfully"));
                    } else {
                        toast.error(t("DocumentCancelFailed"));
                    }
                } catch (error) {
                    console.error("Error cancelling document:", error);
                    const errorMessage = error?.message || "";
                    let errorCodeMatch = errorMessage.match(/Error Code (\d+):/);
                    if (!errorCodeMatch) {
                        errorCodeMatch = errorMessage.match(/Status Code: (\d+),/);
                    }
                    if (errorCodeMatch) {
                        const errorCode = errorCodeMatch[1];
                        toast.error(t(`TaxInvoiceError${errorCode}`), { autoClose: false });
                        if (errorCode === Constants.TaxAuthorityErrorCodes.INVOICE_NOT_APPROVED.toString() ||
                            errorCode === Constants.TaxAuthorityErrorCodes.NO_DECISION_SENT.toString()) {
                            setPendingMergedDataForTaxError(mergedData);
                            setIsTaxAuthorityErrorModalVisible(true);
                        }
                    } else {
                        toast.error(t("DocumentCancelFailed"));
                    }
                } finally {
                    setLocalLoading(false);
                    if (isRange) {
                        await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate))
                    }
                    else
                        await fetchDocuments(new Date(sortDate));
                    return;
                }
            }

            // Normal (non-cancel) generation: refresh the grid so the newly
            // created document appears without requiring a manual page reload.
            if (isRange) {
                await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
            } else {
                await fetchDocuments(new Date(sortDate));
            }
        } catch (err) {
            console.error("Error generating new doc:", err);
            const errorMessage = err?.message || "";
            const overAllocation = parseOverAllocationError(errorMessage);
            if (overAllocation) {
                toast.error(
                    <span style={{ whiteSpace: 'pre-line' }}>{formatOverAllocationMessage(t, overAllocation)}</span>,
                    { autoClose: false }
                );
                return;
            }
            let errorCodeMatch = errorMessage.match(/Error Code (\d+):/);
            if (!errorCodeMatch) {
                errorCodeMatch = errorMessage.match(/Status Code: (\d+),/);
            }
            if (errorCodeMatch) {
                const errorCode = errorCodeMatch[1];
                toast.error(t(`TaxInvoiceError${errorCode}`), { autoClose: false });
                if (errorCode === Constants.TaxAuthorityErrorCodes.INVOICE_NOT_APPROVED.toString() ||
                    errorCode === Constants.TaxAuthorityErrorCodes.NO_DECISION_SENT.toString()) {
                    setPendingMergedDataForTaxError(mergedData);
                    try {
                        const mapEntry = ACTION_TO_TYPE_INDEX[mergedData?.pendingAction?.value];
                        const status = await TaxAuthorityService.getPendingInvoiceDecisionStatus(
                            mergedData?.documentInfo?.caseId || client.caseId,
                            token,
                            documentTypeFromModalIndex(mapEntry?.index)
                        );
                        setPendingDecisionStatus(status);
                        setResolvePendingMode(!!(status?.requiresDecision || status?.RequiresDecision));
                    } catch (e) {
                        setResolvePendingMode(false);
                    }
                    setPendingResumeKind('create');
                    setIsTaxAuthorityErrorModalVisible(true);
                }
            } else if (isDocumentCanceledByAction(mergedData?.pendingAction?.value, mergedData?.documentInfo?.transactionDocumentType)) {
                const serverMsg = errorMessage.replace(/^"(.*)"$/, '$1');
                toast.error(serverMsg || t('DocumentCancelFailed'), { autoClose: false });
            } else {
                const serverMsg = errorMessage.replace(/^"(.*)"$/, '$1');
                toast.error(serverMsg || t('DocumentGenerationFailed'), { autoClose: false });
            }
        } finally {
            setLocalLoading(false);
        }
    };

    const handleTaxAuthorityOptionSelect = (decisionFlag, options) => {
        const merged = pendingMergedDataForTaxError;
        setIsTaxAuthorityErrorModalVisible(false);
        setPendingMergedDataForTaxError(null);
        setResolvePendingMode(false);
        if (decisionFlag === undefined || decisionFlag === null) return;
        // Cancel (0): still generate a zero-amount canceled document
        if (merged) {
            handleGenerateNewDoc(merged, true, {
                decisionFlag,
                forceNoConfirmationNumber: options?.forceNoConfirmationNumber === true,
            });
        }
    };

    const presentGeneratedHeldDocument = (gen) => {
        if (gen?.type === 'pdf' && gen.blob) {
            setFinalPdfBlobs([gen.blob]);
            setPdfModalVisible(true);
            toast.success(t('InvoiceCreated') || t('InvoiceGeneratedSuccessfully') || 'Document created');
            return;
        }
        if (gen?.type === 'json' && gen.data) {
            if (gen.data.presignedUrl) {
                setFinalPdfBlobs([gen.data.presignedUrl]);
                setPdfModalVisible(true);
            } else if (gen.data.pdfBytes) {
                const pdfBytes = Uint8Array.from(atob(gen.data.pdfBytes), (c) =>
                    c.charCodeAt(0)
                );
                setFinalPdfBlobs([new Blob([pdfBytes], { type: 'application/pdf' })]);
                setPdfModalVisible(true);
            }
            toast.success(t('InvoiceCreated') || t('InvoiceGeneratedSuccessfully') || 'Document created');
            return;
        }
        if (gen?.type === 'text') {
            toast.success(gen.message || t('TaxAuthorityRequestSent'));
        }
    };

    const issueHeldDocumentFromSnapshot = async (status, decisionFlag) => {
        setLocalLoading(true);
        try {
            const gen = await TaxAuthorityService.generateDocumentWithDecision(
                status,
                decisionFlag,
                token
            );
            presentGeneratedHeldDocument(gen);
        } catch (e) {
            console.error(e);
            const msg = e?.message || '';
            toast.error(
                msg === 'MissingStoredInvoiceSnapshot'
                    ? t('MissingStoredInvoiceSnapshot')
                    : msg || t('ErrorGeneratingInvoice') || t('Error'),
                { autoClose: false }
            );
        } finally {
            setLocalLoading(false);
        }
    };

    const handlePendingDecisionResolved = async ({ decisionFlag, action, result, invoiceId }) => {
        setResolvePendingMode(false);
        setPendingMergedDataForTaxError(null);
        setPendingResumeKind(null);

        const statusForGenerate = TaxAuthorityService.mergePendingStatusWithHeldRow(
            {
                ...(pendingDecisionStatus || {}),
                ...(result?.pendingStatus || result?.PendingStatus || {}),
            },
            pendingDecisionStatus
        );
        const lockedId =
            invoiceId ||
            statusForGenerate.invoiceId ||
            statusForGenerate.InvoiceId;
        if (lockedId) {
            statusForGenerate.invoiceId = String(lockedId);
            statusForGenerate.InvoiceId = String(lockedId);
        }

        const resolvedStatus =
            result?.pendingStatus ||
            result?.PendingStatus ||
            null;

        if (resolvedStatus) {
            const requires =
                resolvedStatus.requiresDecision ?? resolvedStatus.RequiresDecision;
            if (requires === false || decisionFlag !== 0) {
                setPendingDecisionStatus({
                    ...resolvedStatus,
                    requiresDecision: false,
                    RequiresDecision: false,
                    status: 'DecisionAccepted',
                    Status: 'DecisionAccepted',
                    locallyMarkedSent: decisionFlag !== 0 && action !== 'Cancel',
                });
            } else {
                setPendingDecisionStatus({
                    ...resolvedStatus,
                    requiresDecision: false,
                    RequiresDecision: false,
                    status: 'DecisionAccepted',
                    Status: 'DecisionAccepted',
                    locallyMarkedSent: false,
                });
            }
        } else {
            await refreshPendingDecisionStatus();
        }

        const effectiveDecision =
            decisionFlag === 0 || action === 'Cancel'
                ? 0
                : decisionFlag;

        if (decisionFlag === 0 || action === 'Cancel') {
            toast.info(t('InvoiceCancelledSuccessfully'));
        } else {
            toast.success(
                t('DecisionAccepted') || t('TaxAuthorityDecisionSent') || 'Decision accepted'
            );
        }

        // Always issue the held snapshot SHAAM accepted — not the generate-modal form, which may
        // already be a different document by the time the user confirms the decision.
        await issueHeldDocumentFromSnapshot(statusForGenerate, effectiveDecision);
    };

    // -----------------------------------------------------
    // 6) Handlers for Draft/Final PDF modals
    // -----------------------------------------------------
    const handleCloseDraftPdfModal = () => {
        setDraftPdfModalVisible(false);
        setDraftPdfBlobs([]);
    };

    const handleClosePdfModal = () => {

        setDraftPdfModalVisible(false);
        setDraftPdfBlobs([]);
        setPdfModalVisible(false);
        setFinalPdfBlobs([]);
        setShowAddItemsModal(false);
        setPendingAction(null);
        setCurrentDoc(null);
        setDocItems([]);
        setClientItems([]);
        setShowGenerateModal(false);

    };

    return (
        <>
            <DraggableModal
                bigIframeModalOpen={bigIframeModalOpen}
                openedIframeUrl={openedIframeUrl}
                handleCloseIframeModal={handleCloseIframeModal}
            />
            <>
                <NavigationButton
                    t={t}
                    direction={direction}
                    fileInputRef={fileInputRef}
                    data={buttonData}
                />

                <ReferencesTreeModal
                    open={showRefsModal}
                    caseId={client?.caseId}
                    token={token}
                    onClose={() => setShowRefsModal(false)}
                    onSave={async () => {
                        // Refresh client data after saving references to get updated invoice numbers
                        if (client?.caseId) {
                            try {
                                const updatedClient = await ClientService.GetClient(token, client.caseId);
                                await fetchDocumentsNotification(updatedClient, token);
                            } catch (error) {
                                console.error('Error refreshing client data after saving references:', error);
                            }
                        }
                    }}
                />

                <div className={`searchFilter-bar__container document-toolbar-row ${direction}`}>
                    <Box className="document-filter-row" dir={direction}>
                        {documentsTab === 0 && (
                            <>
                                <TextField
                                    size="small"
                                    dir={direction}
                                    placeholder={t('searchDocuments')}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="document-search-bar"
                                    variant="standard"
                                    InputProps={{
                                        disableUnderline: true,
                                        className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon className="document-search-icon" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <Box sx={{ width: 160, flexShrink: 0, minWidth: 140 }}>
                                    <AutocompleteSelectFilter
                                        options={TransactionDocumentsEnum}
                                        selectedValues={TransactionDocumentsEnum.filter((option) => documentTypes.includes(option.value))}
                                        onChange={(event, newValues) => {
                                            const selected = newValues?.map((item) => item.value) || [];
                                            setDocumentTypes(selected);
                                        }}
                                        label={t('ChooseDocumentType')}
                                        placeholder={t('ChooseDocumentType')}
                                        isMultiple
                                        direction={direction}
                                        portalMenu
                                    />
                                </Box>

                                <Box sx={{ width: 120, flexShrink: 0, minWidth: 120 }}>
                                    <AutocompleteSelectFilter
                                        options={documentStatusFilterOptions}
                                        selectedValues={documentStatusFilterOptions.filter((option) =>
                                            selectedStatuses.includes(option.value)
                                        )}
                                        onChange={(event, newValues) => {
                                            const selected = newValues?.map((item) => item.value) || [];
                                            setSelectedStatuses(selected);
                                        }}
                                        label={t('DocumentOpenClosed')}
                                        placeholder={t('DocumentOpenClosed')}
                                        isMultiple
                                        direction={direction}
                                        portalMenu
                                    />
                                </Box>

                                <Box sx={{ width: 210, flexShrink: 0, minWidth: 168 }}>
                                    <AutocompleteSelectFilter
                                        options={clientFilterOptions}
                                        selectedValues={
                                            selectedClientId
                                                ? clientFilterOptions.find(
                                                    (opt) => String(opt.value) === String(selectedClientId)
                                                )
                                                : null
                                        }
                                        onChange={(event, newValue) => {
                                            setSelectedClientId(newValue?.value ?? null);
                                        }}
                                        label={t('SelectClient')}
                                        placeholder={t('SelectClient')}
                                        isMultiple={false}
                                        searchable
                                        clearable
                                        direction={direction}
                                        portalMenu
                                    />
                                </Box>
    
                                <Box sx={{ width: 210, flexShrink: 0, minWidth: 168 }}>
                                    <AutocompleteSelectFilter
                                        options={makatFilterOptions}
                                        selectedValues={
                                            selectedMakats.length
                                                ? makatFilterOptions.find(
                                                    (opt) => String(opt.value) === String(selectedMakats[0])
                                                )
                                                : null
                                        }
                                        onChange={(event, newValue) => {
                                            setSelectedMakats(newValue?.value != null ? [newValue.value] : []);
                                        }}
                                        label={t('ChooseMakat')}
                                        placeholder={t('ChooseMakat')}
                                        isMultiple={false}
                                        searchable
                                        clearable
                                        direction={direction}
                                        portalMenu
                                    />
                                </Box>
                            </>
                        )}

                        {documentsTab === 0 && (
                            <Box sx={{ width: 220, flexShrink: 0, minWidth: 180 }}>
                                <AutocompleteSelectFilter
                                    options={paymentMethodOptions}
                                    selectedValues={paymentMethodOptions.filter((option) => paymentMethods.includes(option.value))}
                                    onChange={(event, newValues) => {
                                        const selected = newValues?.map((item) => item.value) || [];
                                        setPaymentMethods(selected);
                                    }}
                                    label={t('PaymentMethod')}
                                    placeholder={t('PaymentMethod')}
                                    isMultiple
                                    direction={direction}
                                    portalMenu
                                />
                            </Box>
                        )}



                        <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
                            <span>{t('DateRange')}</span>
                            <input
                                type="checkbox"
                                checked={isRange}
                                onChange={handleRangeChange}
                            />
                            <span className={headerStyles.switchTrack} aria-hidden="true" />
                        </label>

                        {filterByDocumentDate ? (
                            isRange ? (
                                <div className="issued-doc-date-range">
                                    <ReactDatePicker
                                        selected={documentDayStart}
                                        onChange={handleDocumentDayStartChange}
                                        dateFormat="dd/MM/yyyy"
                                        locale="en-GB"
                                        customInput={<IssuedDocumentDateInput placeholder={t('DocumentDateFrom')} />}
                                    />
                                    <ReactDatePicker
                                        selected={documentDayEnd}
                                        onChange={handleDocumentDayEndChange}
                                        dateFormat="dd/MM/yyyy"
                                        locale="en-GB"
                                        customInput={<IssuedDocumentDateInput placeholder={t('DocumentDateTo')} />}
                                    />
                                </div>
                            ) : (
                                <ReactDatePicker
                                    selected={documentDay}
                                    onChange={handleDocumentDayChange}
                                    dateFormat="dd/MM/yyyy"
                                    locale="en-GB"
                                    customInput={<IssuedDocumentDateInput placeholder={t('DocumentDate')} />}
                                />
                            )
                        ) : (
                            isRange ? (
                                <div className={headerStyles.dateSelectRange}>
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={startDate}
                                            month={startDate}
                                            onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                            labelYear={t('StartYear')}
                                            labelMonth={t('StartMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={endDate}
                                            month={endDate}
                                            onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                            labelYear={t('EndYear')}
                                            labelMonth={t('EndMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className={headerStyles.dateSelect}>
                                    <FilterMonthYearPicker
                                        year={sortDate}
                                        month={sortDate}
                                        onYearChange={(newYear) => handleDateChangeNew(newYear, 'year')}
                                        onMonthChange={(newMonth) => handleDateChangeNew(newMonth, 'month')}
                                        labelYear={t('Year')}
                                        labelMonth={t('Month')}
                                        direction={direction}
                                    />
                                </div>
                            )
                        )}

                        <Box className="document-data-view">
                            <span className="document-data-view__label">{t('DocumentDate')}</span>
                            <ToggleButtonGroup
                                value={filterByDocumentDate ? 'document' : 'month'}
                                exclusive
                                onChange={(event, newValue) => {
                                    if (newValue !== null) {
                                        handleDateBasisChange(newValue === 'document');
                                    }
                                }}
                                size="small"
                            >
                                <ToggleButton value="month">{t('Month')}</ToggleButton>
                                <ToggleButton value="document">{t('DocumentDate')}</ToggleButton>
                            </ToggleButtonGroup>
                        </Box>

                        {documentsTab === 0 && (
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<DownloadIconMui />}
                                onClick={handleDownloadIncomeSummary}
                                sx={{
                                    flexShrink: 0,
                                    height: 40,
                                    borderColor: '#304FFF',
                                    color: '#304FFF',
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    whiteSpace: 'nowrap',
                                    '&:hover': { borderColor: '#2539d4', backgroundColor: 'rgba(48, 79, 255, 0.06)' },
                                }}
                            >
                                {t('DownloadIncomeSummary')}
                            </Button>
                        )}

                        {documentsTab === 0 && selectionModel.length > 0 && (
                            <Box sx={{ width: 250, flexShrink: 0, minWidth: 200 }}>
                                <AutocompleteSelectFilter
                                    options={[
                                        { label: t('Print'), value: 'bulk_print' },
                                        { label: t('SendByEmail'), value: 'bulk_email' },
                                        { label: t('SendByWhatsApp'), value: 'bulk_whatsapp' },
                                        { label: t('Download'), value: 'bulk_download' },
                                        ...(() => {
                                            const selectedRows = filteredAndSortedData.filter((r) =>
                                                selectionModel.some((id) => String(id) === String(r.id))
                                            );
                                            const multiConfig = getMultiDocumentGenerateConfig(selectedRows);
                                            if (!multiConfig || !canShowMultiDocumentGenerate(selectedRows, isTaxExempt)) {
                                                return [];
                                            }
                                            return [{
                                                label: t(multiConfig.actionLabel),
                                                value: multiConfig.menuValue,
                                            }];
                                        })(),
                                        ...(selectionModel.length === 1
                                            ? [
                                                { label: `${t('DownloadPDFFile')} (מקור)`, value: 'download_original', isDownload: true },
                                                { label: `${t('DownloadPDFFile')} (העתק)`, value: 'download_copy', isDownload: true },
                                                ...getRowActions(data.find((r) => r.id === selectionModel[0])).map((item) => ({
                                                    label: t(item.label),
                                                    value: item.value,
                                                    isContextMenu: true,
                                                })),
                                            ]
                                            : []),
                                    ]}
                                    selectedValues={null}
                                    onChange={(event, selectedOptions) => {
                                        const selectedOption = Array.isArray(selectedOptions) ? selectedOptions[0] : selectedOptions;
                                        if (!selectedOption) return;
                                        const selectedRow = data.find((r) => r.id === selectionModel[0]);

                                        if (selectedOption.isDownload) {
                                            const downloadType = selectedOption.value.replace('download_', '');
                                            handleDownloadDocument(selectedRow, downloadType);
                                        } else if (
                                            selectedOption.value === 'generate_invoice_multi' ||
                                            selectedOption.value === 'generate_receipt_multi'
                                        ) {
                                            const selectedRows = filteredAndSortedData.filter((r) =>
                                                selectionModel.some((id) => String(id) === String(r.id))
                                            );
                                            handleMultiDocumentGenerate(selectedRows);
                                        } else if (selectedOption.isContextMenu) {
                                            handleActionTriggered(
                                                { label: selectedOption.label, value: selectedOption.value },
                                                selectedRow
                                            );
                                        } else {
                                            handleBulkAction(selectedOption.value, selectionModel);
                                        }
                                    }}
                                    label={t('Actions')}
                                    placeholder={t('SelectAction')}
                                    isMultiple={false}
                                    direction={direction}
                                    portalMenu
                                    searchable
                                />
                            </Box>
                        )}
                    </Box>
                </div>

                <Box sx={{ borderBottom: '1px solid #e8e8e8', mt: 0.5, mb: 0.5 }} dir={direction}>
                    <Tabs
                        value={!hasSelfInvoices && documentsTab === 1 ? 0 : documentsTab}
                        onChange={(_, v) => setDocumentsTab(v)}
                        sx={{
                            minHeight: 40,
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#304FFF',
                                height: 3,
                                borderRadius: '3px 3px 0 0',
                            },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 600,
                                minHeight: 40,
                                fontSize: 'var(--xtram-text-sm, 13px)',
                                color: '#64748b',
                                '&:hover': {
                                    color: '#304FFF',
                                    backgroundColor: 'rgba(48, 79, 255, 0.06)',
                                },
                                '&.Mui-selected': {
                                    color: '#304FFF',
                                },
                            },
                        }}
                    >
                        <Tab value={0} label={t('transactionDocumentsTab') || t('TransactionDocuments') || 'מסמכי עסקה'} />
                        <Tab value={2} label={t('summariesTab')} />
                        {hasSelfInvoices && <Tab value={1} label={t('selfInvoicesTab') || t('SelfInvoice')} />}
                    </Tabs>
                </Box>

                {documentsTab === 2 ? (
                    <TransactionSummariesTab
                        client={client}
                        token={token}
                        direction={direction}
                        documents={data}
                        periodLabel={summaryPeriodLabel}
                        documentTypeOptions={TransactionDocumentsEnum}
                    />
                ) : hasSelfInvoices && documentsTab === 1 ? (
                    <SelfInvoicesTab
                        client={client}
                        token={token}
                        direction={direction}
                        isRange={isRange}
                        sortDate={sortDate}
                        startDate={startDate}
                        endDate={endDate}
                    />
                ) : (
                <>
                {selectionModel.length > 0 && (
                    <Box
                        dir={direction}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            flexWrap: 'wrap',
                            my: 1,
                            px: 1.5,
                            py: 1,
                            borderRadius: '8px',
                            backgroundColor: 'rgba(48, 79, 255, 0.08)',
                            border: '1px solid rgba(48, 79, 255, 0.25)',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 13, color: '#304FFF' }}>
                            {`${selectionModel.length} ${t('SelectedRows')}`}
                        </Typography>
                        <Chip
                            icon={<DownloadIconMui sx={{ fontSize: 16 }} />}
                            label={t('DownloadOriginals')}
                            onClick={handleBulkDownloadOriginals}
                            clickable
                            size="small"
                            sx={{
                                backgroundColor: '#304FFF',
                                color: '#fff',
                                fontWeight: 700,
                                '& .MuiChip-icon': { color: '#fff' },
                                '&:hover': { backgroundColor: '#2539d4' },
                            }}
                        />
                        <Chip
                            icon={<DownloadIconMui sx={{ fontSize: 16 }} />}
                            label={t('DownloadAsOneFile')}
                            onClick={(e) => setMergeMenuAnchorEl(e.currentTarget)}
                            clickable
                            size="small"
                            sx={{
                                backgroundColor: 'rgba(48, 79, 255, 0.12)',
                                color: '#304FFF',
                                fontWeight: 700,
                                border: '1px solid rgba(48, 79, 255, 0.25)',
                                '& .MuiChip-icon': { color: '#304FFF' },
                                '&:hover': { backgroundColor: 'rgba(48, 79, 255, 0.2)' },
                            }}
                        />
                        <Menu
                            anchorEl={mergeMenuAnchorEl}
                            open={Boolean(mergeMenuAnchorEl)}
                            onClose={() => setMergeMenuAnchorEl(null)}
                            anchorOrigin={{ vertical: 'bottom', horizontal: direction === 'rtl' ? 'right' : 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: direction === 'rtl' ? 'right' : 'left' }}
                        >
                            <MenuItem
                                onClick={() => {
                                    setMergeMenuAnchorEl(null);
                                    handleBulkDownloadMerged('original');
                                }}
                            >
                                {t('DownloadAsOneFileOriginal')}
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    setMergeMenuAnchorEl(null);
                                    handleBulkDownloadMerged('copy');
                                }}
                            >
                                {t('DownloadAsOneFileCopy')}
                            </MenuItem>
                        </Menu>
                    </Box>
                )}
                <TransactionDocumentDataGridComponent
                    data={filteredAndSortedData}
                    allDocuments={data}
                    subAccountantOptions={subAccountantOptions}
                    direction={direction}
                    onActionTriggered={handleActionTriggered}
                    selectionModel={selectionModel}
                    onSelectionChange={(newSel) => setSelectionModel(newSel)}
                    onBulkAction={handleBulkAction}
                    openPdfInNewTab={openPdfInNewTab}
                    isTaxExempt={isTaxExempt}
                    token={token}
                    client={client}
                    onDownloadDocument={handleDownloadDocument}
                    resolveContextMenuItems={resolveContextMenuItems}
                    pendingDecisionStatus={pendingDecisionStatus}
                    onOpenPendingDecision={() => {
                        setResolvePendingMode(true);
                        setPendingResumeKind(null);
                        setIsTaxAuthorityErrorModalVisible(true);
                    }}
                />
                </>
                )}


            </>
            {showAddItemsModal && (
                <AddItemsModal
                    open={showAddItemsModal}
                    onClose={() => setShowAddItemsModal(false)}
                    onSave={handleItemsSaved}
                    existingItems={currentDoc?.items || []}
                    items={clientItems}
                    doc={currentDoc}
                    pendingAction={pendingAction}
                />
            )}

            <GenerateDocumentModal
                open={showGenerateModal}
                onClose={() => {
                    setShowGenerateModal(false);
                    setSourceDocs([]);
                    setConversionChildren([]);
                }}
                doc={currentDoc}
                sourceDocs={sourceDocs}
                conversionChildren={conversionChildren}
                docItems={docItems}
                clientItems={clientItems}
                onGenerate={handleDraftGenerateNewDoc}
                pendingAction={pendingAction}
                client={client}
                token={token}
                showNoNeedConfirmationCheckbox={
                    !!client &&
                    !Constants.TaxExemptTypes.includes(client.caseType) &&
                    !!pendingAction &&
                    MODAL_INDICES_TAX_AUTHORITY.includes(ACTION_TO_TYPE_INDEX[pendingAction.value]?.index) &&
                    (pendingAction.value === 'generate_invoice' ||
                        pendingAction.value?.startsWith('cancel_') ||
                        (pendingAction.value === 'generate_credit_invoice' && currentDoc?.transactionDocumentType === 4) ||
                        (pendingAction.value === 'generate_invoice_receipt' &&
                            [ORDER_TYPE, TRANSACTION_ACCOUNT_TYPE, DELIVERY_NOTE_TYPE].includes(
                                Number(currentDoc?.transactionDocumentType)
                            )))
                }
            />

            <ReceiptItemsModal
                open={showReceiptItemsModal}
                onClose={() => setShowReceiptItemsModal(false)}
                doc={pendingDocData?.documentInfo || currentDoc}
                pendingAction={pendingAction}
                onSave={(receiptItems, withholdingTax, doc, roundingAdjustment = 0) => {
                    // The user filled the receipt data => we pass it to your doc creation
                    // E.g., if we were in handleDraftGenerateNewDoc before, call it again:
                    let items = pendingDocData?.items ? [...pendingDocData.items] : [];

                    // If the user applied rounding in the receipt-items modal, append
                    // a synthetic "Rounding Difference" line item with the special
                    // sentinel makat ('-100') so it can be searched for and is never
                    // persisted as a real ClientItem. price equals the adjustment so
                    //   newInvoiceTotal = doc.amount + roundingAdjustment === receiptTotal
                    if (roundingAdjustment && Math.abs(roundingAdjustment) >= 0.005) {
                        // Replace any existing rounding row to avoid stacking duplicates
                        // if the user re-saves after editing.
                        items = items.filter(it => String(it?.makat) !== ROUNDING_MAKAT);
                        items.push({
                            makat: ROUNDING_MAKAT,
                            name: t('RoundingDifference'),
                            quantity: 1,
                            price: Number(roundingAdjustment),
                            discount: 0,
                            includeVat: false, // price is treated as the final delta, no VAT applied
                            itemId: null,
                        });
                    }

                    const newMergedData = {
                        ...pendingDocData,
                        items,
                        invoiceWithholdingTax: withholdingTax,
                        receiptItems,
                    };
                    setShowReceiptItemsModal(false);
                    handleDraftGenerateNewDoc(newMergedData);
                }}
            />

            <CustomDeleteConfirmationModal
                isVisible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                onDelete={handleConfirm}
                confirmMessage={getConfirmMessage()}
                titleMessage={getTitleMessage()}
            />
            <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />

            {/* Draft PDF Modal */}
            <Modal
                open={draftPdfModalVisible}
                onClose={handleCloseDraftPdfModal}
                aria-labelledby="draft-invoice-modal-title"
                aria-describedby="draft-invoice-modal-description"
            >
                <div className="draft-pdf-modal-container" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '24px',
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    margin: '5% auto',
                    width: '90%',

                    height: '85%',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                    overflow: 'hidden',
                }}>
                    {/* PDF Preview Section */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        gap: '16px',
                    }}>
                        {/* Original / source PDF(s) */}
                        {renderMultiSourcePreviewPanel('45%')}

                        {/* Arrow animation */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            animation: 'pulse 2s infinite'
                        }}>
                            <ArrowForwardIcon style={{ fontSize: '36px', color: '#3f51b5' }} />
                        </div>

                        {/* Modified PDF */}
                        {draftPdfBlobs.map((blob, idx) => (
                            <iframe
                                key={idx}
                                src={URL.createObjectURL(blob)}
                                width={draftPdfBlobs.length === 1 ? "45%" : "45%"}
                                height="100%"
                                style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                                aria-label={`Draft PDF ${idx + 1}`}
                            />
                        ))}
                    </div>

                    {/* Button Section */}
                    <div className="draft-pdf-button-container" style={{ width: '100%' }}>
                        <button
                            className="create-invoice-button"
                            onClick={() => {

                                handleGenerateNewDoc(pendingDocData);
                            }}
                        >
                            <span>{t(pendingAction?.label)}</span>
                        </button>

                        <button className="close-invoice-button" onClick={handleCloseDraftPdfModal}>
                            {t('close')}
                        </button>
                    </div>
                </div>
            </Modal>


            {/* Final PDF Modal */}
            <Modal
                open={PdfModalVisible}
                onClose={handleClosePdfModal}
                aria-labelledby="final-invoice-modal-title"
                aria-describedby="final-invoice-modal-description"
            >
                <div
                    className="draft-pdf-modal-container"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        padding: 24,
                        background: "#fff",
                        borderRadius: 12,
                        margin: "5% auto",
                        width: "95%",
                        height: "85%",
                        boxShadow: "0 8px 32px rgba(0,0,0,.2)",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            gap: 16,
                            width: "100%",
                            height: "100%",
                            alignItems: 'center',
                        }}
                    >
                        {isMultiSourcePreview && (
                            <>
                                {renderMultiSourcePreviewPanel('45%')}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <ArrowForwardIcon style={{ fontSize: '36px', color: '#3f51b5' }} />
                                </div>
                            </>
                        )}
                        {finalPdfBlobs.map((blob, idx) => (
                            <iframe
                                key={idx}
                                src={URL.createObjectURL(blob)}
                                width={isMultiSourcePreview
                                    ? '45%'
                                    : (finalPdfBlobs.length === 1 ? '100%' : '50%')}
                                height="100%"
                                style={{ border: "1px solid #ccc", borderRadius: 8 }}
                                aria-label={`Final PDF ${idx + 1}`}
                            />
                        ))}
                    </div>

                    {/* buttons */}
                    <div className="draft-pdf-button-container" style={{ marginTop: 16 }}>
                        <button className="close-invoice-button" onClick={handleClosePdfModal}>
                            {t("close")}
                        </button>
                    </div>
                </div>
            </Modal>


            {loading && (
                <div className="loader-container">
                    <PuffLoader
                        size={100}        // Larger size for better visibility
                        loading={loading}
                    />
                </div>
            )}
            {mergedBlobUrl && (
                <MergedPdfPrint ref={printComponentRef} blobUrl={mergedBlobUrl} />
            )}
            <DocumentChoiceModal
                visible={invoiceModalChoiceVisible}
                onClose={closeCreateInvoiceModal}
                onInvoiceCreator={handleOpenSpecificInvoiceCreator}
                onReceiptCreator={handleOpenSpecificReceiptCreator}
                isTaxExempt={isTaxExempt}
                client={client}
            />
            <EmailModal
                open={showEmailModal}
                onClose={() => setShowEmailModal(false)}
                onSend={actuallySendEmail}
                targetEmails={targetEmails}
                setTargetEmails={setTargetEmails}
                filteredData={filteredAndSortedData}
                selectionModel={selectedIds}
            />

            <WhatsAppModal
                open={showWhatsAppModal}
                onClose={() => setShowWhatsAppModal(false)}
                onSend={actuallySendWhatsApp}
                targetPhones={targetPhones}
                setTargetPhones={setTargetPhones}
                filteredData={filteredAndSortedData}
                selectionModel={selectedIds}
            />

            <DocumentSettingsDialog
                open={documentSettingsModalOpen}
                onClose={handleCloseDocumentSettings}
                onSave={handleDocumentSettingsSave}
                token={token}
                accountantId={client?.accountantId}
                caseId={client?.caseId}
                direction={direction}
                client={client}
            />

            <CancelDocumentsModal
                open={showCancelDocumentsModal}
                onClose={() => setShowCancelDocumentsModal(false)}
                direction={direction}

            />

            <LinkDocumentsModal
                open={!!linkDocumentsTarget}
                onClose={() => setLinkDocumentsTarget(null)}
                caseId={client?.caseId}
                token={token}
                documentId={linkDocumentsTarget?.documentId}
                pairDocumentIds={linkDocumentsTarget?.pairDocumentIds}
                invoiceGroupIds={linkDocumentsTarget?.invoiceGroupIds}
                direction={direction}
                onLinked={handleDocumentsLinked}
            />

            <TaxAuthorityProblemInvoicesModal
                open={showProblemInvoicesModal}
                onClose={() => setShowProblemInvoicesModal(false)}
                caseId={client?.caseId}
                token={token}
                onFinishFromSnapshot={async (row, decisionFlag) => {
                    setShowProblemInvoicesModal(false);
                    await issueHeldDocumentFromSnapshot(row, decisionFlag);
                }}
                onOpenDecision={async (row) => {
                    const invId = row?.invoiceId || row?.InvoiceId;
                    const documentType =
                        row?.documentType || row?.DocumentType || 'TaxInvoice';
                    if (!invId || !client?.caseId || !token) return;
                    try {
                        const status = await TaxAuthorityService.getPendingInvoiceDecisionStatus(
                            client.caseId,
                            token,
                            documentType,
                            invId
                        );
                        const statusWithRowPayload = TaxAuthorityService.mergePendingStatusWithHeldRow(
                            status,
                            row
                        );
                        const freshStatus = status?.status || status?.Status || '';
                        const stillOpen =
                            !!(status?.requiresDecision || status?.RequiresDecision) ||
                            freshStatus === 'AwaitingDocument';

                        // The row was rendered from an earlier snapshot. If the reference has since
                        // been settled — its document issued here or elsewhere — there is nothing to
                        // decide or finish, and opening the dialog would present the decision menu
                        // for a closed reference.
                        if (!stillOpen) {
                            toast.info(
                                t('TaxAuthorityReferenceAlreadyResolved') ||
                                    'This number is already settled at the Tax Authority.'
                            );
                            setShowProblemInvoicesModal(false);
                            return;
                        }

                        setPendingDecisionStatus(statusWithRowPayload);
                        setResolvePendingMode(stillOpen);
                        setPendingResumeKind('problemGenerate');
                        setPendingMergedDataForTaxError(null);
                        setShowProblemInvoicesModal(false);
                        setIsTaxAuthorityErrorModalVisible(true);
                    } catch (e) {
                        console.error(e);
                        toast.error(e?.message || t('Error'));
                    }
                }}
            />

            <TaxAuthorityErrorModal
                open={isTaxAuthorityErrorModalVisible}
                onClose={() => {
                    setIsTaxAuthorityErrorModalVisible(false);
                    setPendingMergedDataForTaxError(null);
                    setResolvePendingMode(false);
                    setPendingResumeKind(null);
                }}
                onOptionSelect={handleTaxAuthorityOptionSelect}
                invoiceData={{
                    invoiceId:
                        pendingDecisionStatus?.invoiceId ||
                        pendingDecisionStatus?.InvoiceId ||
                        pendingMergedDataForTaxError?.documentInfo?.id ||
                        "0",
                }}
                caseId={client?.caseId || "0"}
                token={token}
                pendingStatus={pendingDecisionStatus}
                resolvePending={resolvePendingMode}
                onResolved={async (...args) => {
                    await handlePendingDecisionResolved(...args);
                    // Keep overview fresh next open
                }}
            />

        </>
    );
}


export default TransactionDocuments;
